export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "What are quality gates used for?",
    "description": "They are quality checks at strategic points in the project schedule and ensure the work is accurate and meets quality standards."
  },
  {
    "id": 2,
    "topic_id": 3,
    "title": "What meeting tool can help ensure everyone is reviewing the latest information?",
    "description": "Version control tools."
  },
  {
    "id": 3,
    "topic_id": 2,
    "title": "What is solutions design?",
    "description": "This ensures the technology solution fits within the IT enterprise and that it meets the objectives of the project and the organization. It involves designing the technical solution that will solve the business problem and measures outcomes to make sure the final product meets the business expectations."
  },
  {
    "id": 4,
    "topic_id": 4,
    "title": "Describe PRINCE2.",
    "description": "This is a project management methodology that can be used for any size project in any industry. It manages the project in stages, step by step, to keep the project in control."
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "What is burn rate?",
    "description": "The rate at which you are spending project funds over time."
  },
  {
    "id": 6,
    "topic_id": 1,
    "title": "What is a force majeure risk?",
    "description": "A risk that is catastrophic in nature and is outside the control of the organization."
  },
  {
    "id": 7,
    "topic_id": 1,
    "title": "This chart is used on agile projects to display the amount of work completed to date against the entire project.",
    "description": "A burnup chart."
  },
  {
    "id": 8,
    "topic_id": 1,
    "title": "Describe SDLC.",
    "description": "This is a development methodology that stands for software development life cycle. It consists of phases such as planning, defining, designing, building, testing, and deploying. Waterfall and agile are types of SDLC methodologies."
  },
  {
    "id": 9,
    "topic_id": 1,
    "title": "Define the XaaS cloud model.",
    "description": "This is any IT function converted to a cloud model for use by the organization. It provides a platform where users can access Iaas, PaaS, and SaaS providers as well as their on-premises services."
  },
  {
    "id": 10,
    "topic_id": 1,
    "title": "What are the key roles in the Scrum methodology?",
    "description": "The Scrum master, product owner, and Scrum team members."
  },
  {
    "id": 11,
    "topic_id": 2,
    "title": "Describe a minimally viable product (MVP).",
    "description": "MVP involves breaking down tasks into tangible components that have enough features and functionality to allow the customer to examine value and provide feedback to the team. They are often prototypes or mock-ups."
  },
  {
    "id": 12,
    "topic_id": 3,
    "title": "This agile chart can show changes in scope.",
    "description": "A burnup chart."
  },
  {
    "id": 13,
    "topic_id": 1,
    "title": "Where should escalation procedures for communications be described and documented?",
    "description": "In the communication plan."
  },
  {
    "id": 14,
    "topic_id": 1,
    "title": "What is a user story?",
    "description": "User stories document the functionality or requirements for the program and actors who will benefit from this requirement. They are written from the perspective of the customer."
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "What type of estimating technique involves people who have worked on similar projects or tasks?",
    "description": "Expert judgment."
  },
  {
    "id": 16,
    "topic_id": 4,
    "title": "Define a business acquisition.",
    "description": "A business acquisition is a type of organizational change. Business acquisition occurs when one business takes over another and they become one entity. The organization performing the acquisition has all the power and authority in this situation."
  },
  {
    "id": 17,
    "topic_id": 1,
    "title": "How are operations different than projects?",
    "description": "Projects have a beginning and ending date, exist to create a unique product, service, or result, and come about to fulfill the goals of the organization. Operations are ongoing and repetitive."
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "How are cost baselines displayed?",
    "description": "As S-curves, because spending starts out slowly at the beginning of the project, picks up as the project progresses, and slows again at the end of the project."
  },
  {
    "id": 19,
    "topic_id": 4,
    "title": "Who is typically responsible for writing the project charter?",
    "description": "The project manager."
  },
  {
    "id": 20,
    "topic_id": 2,
    "title": "Describe lessons learned.",
    "description": "Lessons learned describe the successes and failures of the project and should never be used to place blame."
  },
  {
    "id": 21,
    "topic_id": 3,
    "title": "What are the two keys to a successful rewards and recognition program?",
    "description": "That rewards and recognition are applied consistently and that the reward or recognition is appropriate for the level of effort expended or the results achieved."
  },
  {
    "id": 22,
    "topic_id": 2,
    "title": "What is cloud computing?",
    "description": "This service allows for the sharing of software, information, data, and services to computers and technology devices on demand from the cloud."
  },
  {
    "id": 23,
    "topic_id": 2,
    "title": "What does a communication plan document?",
    "description": "This documents who needs information, what type, when, in what format, and the frequency of the communication."
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "This is a type of chart that shows cause and effects.",
    "description": "Fishbone or Ishikawa diagram."
  },
  {
    "id": 25,
    "topic_id": 1,
    "title": "Describe make-or-buy analysis.",
    "description": "This technique determines whether it is more cost effective to produce the resources in-house (or use existing human resources within the organization) or procure them from an outside vendor."
  },
  {
    "id": 26,
    "topic_id": 2,
    "title": "What are critical success factors?",
    "description": "Those elements that must be completed accurately and on schedule in order for the project to be considered complete."
  },
  {
    "id": 27,
    "topic_id": 1,
    "title": "A well-managed change control process can help stop this phenomenon.",
    "description": "Scope creep."
  },
  {
    "id": 28,
    "topic_id": 2,
    "title": "Name several types of communication methods.",
    "description": "Communication methods include: meetings, email, fax, instant messaging, videoconferencing, voice conferencing, face-to-face, SMS or text messages, distribution of printed media, and social media."
  },
  {
    "id": 29,
    "topic_id": 4,
    "title": "Define PV.",
    "description": "PV (planned value) is the cost of work that has been authorized and budgeted for a work component during a given timeframe. This is a figure used in EVM formulas."
  },
  {
    "id": 30,
    "topic_id": 1,
    "title": "Who is typically responsible for signing the project charter?",
    "description": "The project sponsor."
  },
  {
    "id": 31,
    "topic_id": 1,
    "title": "Name the traits that define a project.",
    "description": "It\u2019s temporary in nature, has a definite start and end date, and delivers a unique product, service, or result."
  },
  {
    "id": 32,
    "topic_id": 2,
    "title": "What type of change request is implemented to correct or replace components that are substandard or are malfunctioning?",
    "description": "Defect repairs."
  },
  {
    "id": 33,
    "topic_id": 1,
    "title": "These performance measures help you determine whether the project is progressing as planned.",
    "description": "Key performance indicators (KPIs)."
  },
  {
    "id": 34,
    "topic_id": 2,
    "title": "What is the longest full path through a network diagram?",
    "description": "Critical path."
  },
  {
    "id": 35,
    "topic_id": 1,
    "title": "An activity that cannot start until its predecessor has concluded is said to have what type of logical relationship?",
    "description": "Finish-to-start."
  },
  {
    "id": 36,
    "topic_id": 1,
    "title": "Name the common types of project changes.",
    "description": "Timeline, funding, risk events, requirements, quality, resource, and scope."
  },
  {
    "id": 37,
    "topic_id": 3,
    "title": "What type of contract is riskiest to the buyer?",
    "description": "Cost reimbursable."
  },
  {
    "id": 38,
    "topic_id": 1,
    "title": "What are four types of cloud deployments?",
    "description": "Private cloud, community cloud, public cloud, and hybrid cloud."
  },
  {
    "id": 39,
    "topic_id": 4,
    "title": "Name the estimating technique that bases estimates on past projects of similar size and scope.",
    "description": "Analogous estimating."
  },
  {
    "id": 40,
    "topic_id": 1,
    "title": "What is the lowest level of the WBS?",
    "description": "The work package."
  },
  {
    "id": 41,
    "topic_id": 4,
    "title": "What two things does the project sponsor put into motion at the signing of the project charter?",
    "description": "Authorizes the project to begin and authorizes the use of resources."
  },
  {
    "id": 42,
    "topic_id": 1,
    "title": "This describes an activity that can\u2019t be scheduled until the previous activity is complete.",
    "description": "Predecessor."
  },
  {
    "id": 43,
    "topic_id": 1,
    "title": "What is the final, approved schedule that will be used to monitor and track all the work of the project?",
    "description": "Schedule baseline."
  },
  {
    "id": 44,
    "topic_id": 1,
    "title": "The risk score is calculated using this tool.",
    "description": "Probability and impact matrix."
  },
  {
    "id": 45,
    "topic_id": 1,
    "title": "How is actual burn rate calculated?",
    "description": "Total expenses to date / time periods at measurement date."
  },
  {
    "id": 46,
    "topic_id": 1,
    "title": "Name the PMI standard that documents the de facto standards in project management.",
    "description": "The <i>PMBOK</i>\u00ae<i> Guide.</i>"
  },
  {
    "id": 47,
    "topic_id": 2,
    "title": "Constraint reprioritization, interaction between constraints, and other projects are examples of what?",
    "description": "Influences that can impact or change the project constraints."
  },
  {
    "id": 48,
    "topic_id": 4,
    "title": "Describe a Pareto chart.",
    "description": "This chart displays the frequency of rank-ordered values over time."
  },
  {
    "id": 49,
    "topic_id": 2,
    "title": "Name the two main types of computer storage and give an example of each.",
    "description": "Primary storage such as RAM and ROM, and secondary storage such as hard drives, flash drives, NAS, and SANs."
  },
  {
    "id": 50,
    "topic_id": 4,
    "title": "This describes the deliverables-oriented hierarchy that defines the work of the project.",
    "description": "Work breakdown structure."
  },
  {
    "id": 51,
    "topic_id": 1,
    "title": "Describe a program.",
    "description": "A group of related projects that are managed together using coordinated processes and techniques. This can bring about benefits that wouldn\u2019t be achievable if the projects were managed separately."
  },
  {
    "id": 52,
    "topic_id": 4,
    "title": "What type of change request is implemented to help reduce the probability of a negative risk event?",
    "description": "Preventive actions."
  },
  {
    "id": 53,
    "topic_id": 1,
    "title": "What is a product manager?",
    "description": "This role oversees the existing products and the development of new products for the organization. They meet with stakeholders and customers, determine strategy, create requirements, and oversee development of the products."
  },
  {
    "id": 54,
    "topic_id": 1,
    "title": "Describe the project management plan.",
    "description": "This is a document, or assortment of documents, including the project baselines, that constitutes what the project is, what the project will deliver, and how all the processes will be managed. It\u2019s used as the guideline throughout the project phases to track and measure project performance and to make future project decisions."
  },
  {
    "id": 55,
    "topic_id": 2,
    "title": "Describe SWOT analysis.",
    "description": "This involves analyzing the project from each the perspective of the organization\u2019s strengths, weaknesses, opportunities, and threats."
  },
  {
    "id": 56,
    "topic_id": 2,
    "title": "What document is where you\u2019ll define the information needs for the project stakeholders, including when, how, what format, and frequency?",
    "description": "Communications plan."
  },
  {
    "id": 57,
    "topic_id": 2,
    "title": "This funding allocation is set aside by the management team to cover future expenses on the project that can\u2019t be planned for.",
    "description": "Management reserve."
  },
  {
    "id": 58,
    "topic_id": 1,
    "title": "Name the project management life cycle phase that begins when the project charter is approved.",
    "description": "Planning."
  },
  {
    "id": 59,
    "topic_id": 4,
    "title": "This chart plots two numerical variables to determine if there is a correlation between the data points.",
    "description": "Scatter diagram."
  },
  {
    "id": 60,
    "topic_id": 2,
    "title": "Name the three types of matrix organizations.",
    "description": "Strong, weak, and balanced."
  },
  {
    "id": 61,
    "topic_id": 4,
    "title": "Which element of the scope statement documents the process and criteria you\u2019ll use to determine whether deliverables are complete and satisfactory?",
    "description": "Acceptance criteria."
  },
  {
    "id": 62,
    "topic_id": 4,
    "title": "Name the project phase where project sign-off of a successful project is obtained.",
    "description": "Closing."
  },
  {
    "id": 63,
    "topic_id": 1,
    "title": "Name the types of documents you could use during the vendor solicitation process.",
    "description": "Request for information (RFI), request for proposal (RFP), request for bid (RFB), request for quotations (RFQ), master service agreement (MSA), purchase order (PO), terms of reference (TOR)."
  },
  {
    "id": 64,
    "topic_id": 1,
    "title": "Define a customer relationship software system (CRM).",
    "description": "Software that helps businesses manage their relationships and interactions with their customers and future customers. CRMs aggregate data about the customer in one place and provide an efficient and practical way for the organization to interact with their customer."
  },
  {
    "id": 65,
    "topic_id": 2,
    "title": "What type of requirement describes the high-level results of fulfilling a project and how they satisfy business goals, strategy, and perspective?",
    "description": "Business requirements."
  },
  {
    "id": 66,
    "topic_id": 4,
    "title": "What is expenditure reporting?",
    "description": "The mechanism you\u2019ll use to report on the current state of the project budget."
  },
  {
    "id": 67,
    "topic_id": 1,
    "title": "What is the purpose of the project charter?",
    "description": "The project charter normally approves the project and authorizes it to begin."
  },
  {
    "id": 68,
    "topic_id": 3,
    "title": "Which project phase deals with risks, the issue log, performance measurements, quality assurance, and change control?",
    "description": "Executing."
  },
  {
    "id": 69,
    "topic_id": 4,
    "title": "This system ensures the project doesn\u2019t deviate from the planned requirements and manages changes requests.",
    "description": "Change control system."
  },
  {
    "id": 70,
    "topic_id": 2,
    "title": "What does the project description describe?",
    "description": "This describes the product, service, or result that will be created by the project. The project description documents the relationship between the product being created and the business need that drove the project request."
  },
  {
    "id": 71,
    "topic_id": 1,
    "title": "Task estimating by using people who are familiar with the tasks is called what?",
    "description": "Expert judgment."
  },
  {
    "id": 72,
    "topic_id": 1,
    "title": "State the purpose of the change request log.",
    "description": "The change request log records change requests and their dispositions. It should include an identifying number, date, description, requestor, status, and final disposition."
  },
  {
    "id": 73,
    "topic_id": 1,
    "title": "This procurement document details the deliverables the vendor must provide, the characteristics of the deliverables, and other information similar to the scope statement.",
    "description": "Statement of work (SOW)."
  },
  {
    "id": 74,
    "topic_id": 1,
    "title": "Define a data warehouse.",
    "description": "A system that collects, organizes, centralizes, and manages data. The data is used and analyzed by managers and executives to make decisions about the business."
  },
  {
    "id": 75,
    "topic_id": 1,
    "title": "What is the most often used logical relationship?",
    "description": "Finish-to-start."
  },
  {
    "id": 76,
    "topic_id": 4,
    "title": "Who is responsible for developing the project plan?",
    "description": "The project manager."
  },
  {
    "id": 77,
    "topic_id": 1,
    "title": "In which project management life cycle phase is the project charter document created?",
    "description": "Initiating."
  },
  {
    "id": 78,
    "topic_id": 1,
    "title": "What describes each of the deliverables and their components, the code of accounts identifier, estimates, resources, and criteria for acceptance?",
    "description": "The WBS dictionary."
  },
  {
    "id": 79,
    "topic_id": 2,
    "title": "What is the term for a symptom that means a risk event is about to occur?",
    "description": "Risk trigger."
  },
  {
    "id": 80,
    "topic_id": 1,
    "title": "Name the components in a business case.",
    "description": "Description, justification, alignment to the strategic plan, stakeholders, analysis of problem or opportunity, high-level risk analysis, alternative solutions, recommended solution, and feasibility results."
  },
  {
    "id": 81,
    "topic_id": 1,
    "title": "Describe functional requirements.",
    "description": "The product characteristics needed for the product to perform. They are typically behavioral in nature or performance oriented."
  },
  {
    "id": 82,
    "topic_id": 2,
    "title": "Name the term that describes processes that are repeated.",
    "description": "Iterative."
  },
  {
    "id": 83,
    "topic_id": 1,
    "title": "Name the purpose for archiving project documents.",
    "description": "Archiving helps produce proof the project was accepted and signed off, and it gives others access to the project documents so that they can be used as a reference on future projects."
  },
  {
    "id": 84,
    "topic_id": 1,
    "title": "What is a database?",
    "description": "A collection of data that is stored electronically in a computer system that can be easily accessed by other computer systems and by humans."
  },
  {
    "id": 85,
    "topic_id": 1,
    "title": "Three-point estimates use which three estimates to calculate the average estimate?",
    "description": "Most likely, pessimistic, and optimistic."
  },
  {
    "id": 86,
    "topic_id": 1,
    "title": "What formal document contains all of the plans created during the project process group?",
    "description": "Project management plan."
  },
  {
    "id": 87,
    "topic_id": 2,
    "title": "Define a portfolio.",
    "description": "A portfolio is a collection of programs, projects, and subportfolios that support the strategic goals of the portfolio and/or the organization. Projects and programs within the portfolio are not necessarily related to one another."
  },
  {
    "id": 88,
    "topic_id": 1,
    "title": "Define AC.",
    "description": "AC (actual cost) is the actual cost of completing the work component in a given time period. This is a figure used in EVM formulas."
  },
  {
    "id": 70,
    "topic_id": 2,
    "title": "What does the project description describe?",
    "description": "This describes the product, service, or result that will be created by the project. The project description documents the relationship between the product being created and the business need that drove the project request."
  },
  {
    "id": 89,
    "topic_id": 1,
    "title": "Name four types of project endings.",
    "description": "Addition, starvation, integration, and extinction."
  },
  {
    "id": 90,
    "topic_id": 1,
    "title": "What event should you coordinate after the project charter is signed and the project resources have been identified? This may also occur later in the Planning phase once most team members are assigned to the project.",
    "description": "The project kickoff meeting."
  },
  {
    "id": 91,
    "topic_id": 2,
    "title": "Name the purpose of the scope management plan.",
    "description": "It documents how scope will be defined and verified, and it describes how scope will be monitored and controlled throughout the life of the project."
  },
  {
    "id": 92,
    "topic_id": 1,
    "title": "Name the types of meetings held on agile teams.",
    "description": "Daily standups, iteration review, backlog refinement, and retrospective."
  },
  {
    "id": 93,
    "topic_id": 1,
    "title": "These types of resources are in between assignments or projects.",
    "description": "Benched resources."
  },
  {
    "id": 94,
    "topic_id": 2,
    "title": "What is an electronic document and records management system (EDRMS)?",
    "description": "A software system that manages electronic documents, records, and data from creation to disposal."
  },
  {
    "id": 95,
    "topic_id": 1,
    "title": "Describe a backlog refinement meeting.",
    "description": "This meeting occurs mid-way during the iteration and provides the team with an opportunity to review user stories for the upcoming iteration. This review also examines user stories from the perspective of the entire project."
  },
  {
    "id": 96,
    "topic_id": 2,
    "title": "Name some of the common communication triggers on projects.",
    "description": "Audits, project planning, project change, risk register updates, milestones, schedule changes, task initiation/completion, stakeholder changes, gate reviews, business continuity response, incident response, and resource changes."
  },
  {
    "id": 97,
    "topic_id": 4,
    "title": "What is the difference between starvation and integration project endings?",
    "description": "Integration is the reassignment of resources to other projects or activities, and starvation is having resources cut."
  },
  {
    "id": 98,
    "topic_id": 1,
    "title": "What activity should occur periodically throughout the project life cycle in regard to risk?",
    "description": "Risk reviews to determine if the risks are still relevant and to identify and add new risk events to the risk register that were not previously identified."
  },
  {
    "id": 99,
    "topic_id": 3,
    "title": "Who is ultimately responsible for the project\u2019s outcome?",
    "description": "The project manager."
  },
  {
    "id": 100,
    "topic_id": 2,
    "title": "Name the five project management life cycle phases according to CompTIA.",
    "description": "Discovery/Concept, Initiating, Planning, Executing, Closing."
  },
  {
    "id": 101,
    "topic_id": 1,
    "title": "What entity is responsible for reviewing change requests and approving, denying, or delaying their implementation?",
    "description": "The change control board."
  },
  {
    "id": 102,
    "topic_id": 2,
    "title": "This component of the project scope statement documents the deliverables or items that will not be included in the project.",
    "description": "Exclusions."
  },
  {
    "id": 103,
    "topic_id": 2,
    "title": "What is the formula to calculate the weighted average duration of a project often used in PERT?",
    "description": "(Optimistic + pessimistic + (4  most likely)) / 6."
  },
  {
    "id": 104,
    "topic_id": 2,
    "title": "Name several activities that occur in the Executing phase.",
    "description": "Execute tasks, implement organizational change management, manage vendors, conduct project meetings, report on and track project performance, update the budget, update the timeline, manage conflict, and coordinate phase gate reviews."
  },
  {
    "id": 105,
    "topic_id": 2,
    "title": "Name the stages of team development.",
    "description": "Forming, storming, norming, performing, and adjourning."
  },
  {
    "id": 106,
    "topic_id": 1,
    "title": "What is an enterprise resource planning (ERP) system?",
    "description": "A system that coordinates back-office business activities such as accounting, procurement, and human resources."
  },
  {
    "id": 107,
    "topic_id": 1,
    "title": "Name several factors that influence communication methods.",
    "description": "Language barriers, time zones/geographical factors, technological factors, cultural differences, interorganizational differences, intraorganizational differences, personal preferences, rapport building/relationship building, tailor method based on content of message, criticality factors, and specific stakeholder communication requirements."
  },
  {
    "id": 108,
    "topic_id": 1,
    "title": "Some companies have a centralized area where all formal project management activities take place. What is this area called?",
    "description": "Project management office (PMO)."
  },
  {
    "id": 109,
    "topic_id": 4,
    "title": "Which chart type is useful for showing the dependency relationships between tasks?",
    "description": "Network diagrams."
  },
  {
    "id": 110,
    "topic_id": 1,
    "title": "What is the formula for CPI?",
    "description": "CPI = EV/AC."
  },
  {
    "id": 111,
    "topic_id": 1,
    "title": "Describe a scoring model.",
    "description": "A scoring model has predefined list of criteria against which each alternative solution or project is rated. Each criterion is given both a scoring range and a weighting factor. The weighting factor accounts for the difference in importance of the various criteria. Weights are determined by the organization. Projects with the highest score should be selected."
  },
  {
    "id": 112,
    "topic_id": 1,
    "title": "What type of requirement describes a behavior, specification, quantity, or color?",
    "description": "Functional."
  },
  {
    "id": 113,
    "topic_id": 3,
    "title": "Why is project sign-off important?",
    "description": "Sign-off signals the acceptance of the final product, service, or result of the project and transitions the product to the organization."
  },
  {
    "id": 114,
    "topic_id": 1,
    "title": "What are ESG factors?",
    "description": "Factors that may influence project management activities involving environmental, social, and governance activities as well as awareness of company vision, mission statement, and values, impacts to company brand value, impact to local and global environment, and awareness of applicable regulations and standards."
  },
  {
    "id": 115,
    "topic_id": 2,
    "title": "Placing activities into a logical sequence and determining their dependencies is called what?",
    "description": "Activity sequencing."
  },
  {
    "id": 116,
    "topic_id": 1,
    "title": "Why are vendor reviews held and what do they typically involve?",
    "description": "To determine whether the vendor is performing according to the terms of the contract. They examine elements such as scope, quality standards, budgets, and timelines."
  },
  {
    "id": 117,
    "topic_id": 1,
    "title": "Describe payback period.",
    "description": "A cash flow technique that identifies the length of time it takes for the organization to recover all the costs of producing the project. It compares the initial investment to the expected cash inflows over the life of the project and determines how many time periods elapse before the project pays for itself."
  },
  {
    "id": 118,
    "topic_id": 1,
    "title": "Name the positive risk response strategies.",
    "description": "Exploit, share, enhance, and accept."
  },
  {
    "id": 119,
    "topic_id": 4,
    "title": "What is the formula for CV?",
    "description": "CV = EV \u2013 AC."
  },
  {
    "id": 120,
    "topic_id": 1,
    "title": "What types of activities are the responsibility of the SMEs?",
    "description": "They contribute expertise to the project, work on deliverables according to the project schedule, estimate task durations, estimate costs, and provide dependencies."
  },
  {
    "id": 121,
    "topic_id": 1,
    "title": "What is a stakeholder?",
    "description": "A person or organization that has a vested interest in the project."
  },
  {
    "id": 122,
    "topic_id": 1,
    "title": "What is typically the last document written at the conclusion of a project?",
    "description": "The project close report, which serves as a final project status report."
  },
  {
    "id": 123,
    "topic_id": 1,
    "title": "This is a chart that plots data points on a line over time.",
    "description": "Run chart."
  },
  {
    "id": 124,
    "topic_id": 1,
    "title": "What is interproject resource contention?",
    "description": "Resources that are assigned to more than one project and are needed at the same time on all projects."
  },
  {
    "id": 125,
    "topic_id": 1,
    "title": "What are critical success factors?",
    "description": "Those items that must be delivered or produced accurately and on schedule to consider the project complete."
  },
  {
    "id": 126,
    "topic_id": 2,
    "title": "What are some examples of collaborative meeting types?",
    "description": "Workshops, focus groups, JAD sessions, and brainstorming."
  },
  {
    "id": 127,
    "topic_id": 1,
    "title": "What are some examples of informative meeting types?",
    "description": "Demonstrations/presentations, standups, and project status meetings."
  },
  {
    "id": 128,
    "topic_id": 2,
    "title": "Before assembling the project team, what needs must the project manager assess first, and what type of analysis can be performed to determine this?",
    "description": "Skills required by team members need to be determined using a gap analysis."
  },
  {
    "id": 129,
    "topic_id": 1,
    "title": "Define information technology.",
    "description": "This involves the use of computers and computer networks to create, store, process, and transmit electronic information. Infrastructure consists of all the hardware, software, servers, networks, datacenters, and more that make up and support IT activities for an organization."
  },
  {
    "id": 130,
    "topic_id": 1,
    "title": "What are some examples of decisive meeting types?",
    "description": "Backlog refinement, task setting, sprint planning meetings, and project steering committees."
  },
  {
    "id": 131,
    "topic_id": 1,
    "title": "This is a type of bar chart that shows data points plotted over time.",
    "description": "Histogram."
  },
  {
    "id": 132,
    "topic_id": 1,
    "title": "This document contains information about the risks, including descriptions, risk owners, risk scores, and response plans.",
    "description": "The risk register."
  },
  {
    "id": 133,
    "topic_id": 1,
    "title": "What is an end user?",
    "description": "People or organizations that will use the system you are developing."
  },
  {
    "id": 134,
    "topic_id": 1,
    "title": "Describe cost of capital.",
    "description": "The rate of return the organization might earn if they chose to invest in something other than the project."
  },
  {
    "id": 135,
    "topic_id": 1,
    "title": "Name two activities that can be used to examine vendor performance.",
    "description": "Audits and inspections."
  },
  {
    "id": 136,
    "topic_id": 1,
    "title": "Name the major elements of a scope statement.",
    "description": "Project description, key deliverables, acceptance criteria, exclusions, assumptions, and constraints."
  },
  {
    "id": 137,
    "topic_id": 1,
    "title": "These describe the characteristics of the functional requirements.",
    "description": "Nonfunctional requirements."
  },
  {
    "id": 138,
    "topic_id": 1,
    "title": "Describe float.",
    "description": "Float is the difference in length of time between the early start and late start (or the early finish and late finish) of activity task on the project."
  },
  {
    "id": 139,
    "topic_id": 1,
    "title": "How are changes managed on a contract?",
    "description": "By using a contract change control system."
  },
  {
    "id": 140,
    "topic_id": 4,
    "title": "Name the various types of resources that may be needed for a project.",
    "description": "Human resources, physical resources, capital resources, internal resources, external resources, shared resources, dedicated resources."
  },
  {
    "id": 141,
    "topic_id": 2,
    "title": "What is infrastructure as it relates to IT?",
    "description": "Infrastructure consists of all the hardware, software, servers, networks, datacenters, and more that make up and support IT activities for an organization."
  },
  {
    "id": 142,
    "topic_id": 2,
    "title": "Name the elements required to prepare for meetings.",
    "description": "Creating agendas, determining meeting roles, timeboxing agenda items and meetings, reviewing action items, preparing meeting minutes, and following up."
  },
  {
    "id": 143,
    "topic_id": 1,
    "title": "What is the project baseline?",
    "description": "This includes the approved schedule, cost, scope, and quality plans and documents. It\u2019s used to measure performance as the project progresses."
  },
  {
    "id": 144,
    "topic_id": 1,
    "title": "What type of scheduling chart represents task durations on a timeline and typically displays dependencies?",
    "description": "Gantt."
  },
  {
    "id": 145,
    "topic_id": 1,
    "title": "What document represents the decomposition of the deliverables and work required for a project?",
    "description": "Work breakdown structure."
  },
  {
    "id": 146,
    "topic_id": 1,
    "title": "What is the formula for SV?",
    "description": "SV = EV \u2013 PV."
  },
  {
    "id": 147,
    "topic_id": 2,
    "title": "What is the discounted cash flow technique and how is it calculated?",
    "description": "This is cash flow technique that compares the value of the future worth of the project\u2019s expected cash flows to today\u2019s dollars. It is calculated by finding the present value of each of the cash inflows and then summing those totals."
  },
  {
    "id": 148,
    "topic_id": 1,
    "title": "Describe a product backlog in the agile methodology.",
    "description": "The backlog is the list of items (or requirements) to work on for the project. The product owner establishes and prioritizes the backlog."
  },
  {
    "id": 149,
    "topic_id": 2,
    "title": "Describe smoke testing.",
    "description": "A high-level test used to identify simple failures early in the coding process."
  },
  {
    "id": 150,
    "topic_id": 1,
    "title": "Describe DevOps teams.",
    "description": "This is a team in the IT department that combines the development staff with the operations staff to improve collaboration and deliver projects faster."
  },
  {
    "id": 151,
    "topic_id": 2,
    "title": "Describe a LAN.",
    "description": "A local area network is used in a specific location such as a school or a business. The LAN connects the technology and devices used by the organization to each other so they can share information, utilize software and services, and communicate with each other."
  },
  {
    "id": 152,
    "topic_id": 1,
    "title": "Name the three types of schedule formats used on most projects.",
    "description": "Gantt charts, PERT charts (a type of network diagram), and milestone charts."
  },
  {
    "id": 153,
    "topic_id": 4,
    "title": "What is a contested change?",
    "description": "Contested changes typically involve a disagreement about compensation to the vendor for making requested changes."
  },
  {
    "id": 154,
    "topic_id": 1,
    "title": "What is the formula for present value?",
    "description": "PV = FV / (1 + i)<sup><i> n.</i></sup>"
  },
  {
    "id": 155,
    "topic_id": 3,
    "title": "Name the estimating technique that is a quantitatively based estimating method.",
    "description": "Parametric estimating."
  },
  {
    "id": 156,
    "topic_id": 1,
    "title": "What is a project artifact?",
    "description": "Work products used in managing the project such as the project management plan."
  },
  {
    "id": 157,
    "topic_id": 1,
    "title": "Describe unit testing.",
    "description": "Tests performed on individual modules or units of code."
  },
  {
    "id": 158,
    "topic_id": 1,
    "title": "Name three important purposes for the project kickoff meeting.",
    "description": "To provide a project overview, to review stakeholder expectations, and to review roles and responsibilities."
  },
  {
    "id": 159,
    "topic_id": 2,
    "title": "Describe a DevSecOps team.",
    "description": "This is a team in the IT department that combines the development staff with the security staff and with the operations staff to improve collaboration and deliver projects faster with fidelity."
  },
  {
    "id": 160,
    "topic_id": 4,
    "title": "What are some examples of collaboration tools you can use for project communications?",
    "description": "Multi-authoring and editing software, file sharing platforms, workflow and e-signature platforms, whiteboards, and a wiki knowledge base."
  },
  {
    "id": 161,
    "topic_id": 2,
    "title": "Describe trust building.",
    "description": "Doing what you say you\u2019ll do, demonstrating respect, integrity, honesty, and competency."
  },
  {
    "id": 162,
    "topic_id": 1,
    "title": "What is multitiered architecture?",
    "description": "This refers to physically separating technology functions into their own modules. Three-tier architecture is the most common form of multitiered architecture. It consists of a presentation tier, a processing tier, and a data tier."
  },
  {
    "id": 163,
    "topic_id": 1,
    "title": "What tool can use in a meeting to obtain feedback from the participants?",
    "description": "Real-time surveys and polling tools."
  },
  {
    "id": 164,
    "topic_id": 1,
    "title": "Name three ways to present project status information.",
    "description": "Project status reports, dashboards, and charts."
  },
  {
    "id": 165,
    "topic_id": 1,
    "title": "What is a pull-based system?",
    "description": "A system whereby tasks progress from one state to another (on columns on a Kanban board, for example), and a new task is pulled from the previous state. Scrum and Kanban are known as pull systems."
  },
  {
    "id": 166,
    "topic_id": 1,
    "title": "What are the four types of risk analysis according to the CompTIA objectives?",
    "description": "Impact analysis, qualitative analysis, quantitative analysis, and situational/scenario-based analysis."
  },
  {
    "id": 167,
    "topic_id": 1,
    "title": "Describe Monte Carlo analysis when used to analyze risks.",
    "description": "Monte Carlo analysis is a quantitative risk analysis technique. It is a simulation technique that typically uses cost and schedule variables as inputs. Multiple simulations are run using these variables to estimate potential outcomes."
  },
  {
    "id": 168,
    "topic_id": 1,
    "title": "What is reverse resource allocation?",
    "description": "A scheduling technique in which key or unique resources are required at a certain point in the project. The resources must be scheduled in reverse order, from the end date of the project rather than from the beginning."
  },
  {
    "id": 169,
    "topic_id": 4,
    "title": "What comprises the scope baseline?",
    "description": "The approved scope statement, WBS, and WBS dictionary."
  },
  {
    "id": 170,
    "topic_id": 1,
    "title": "Name some of the considerations you can use when defining probability and impact using qualitative risk analysis.",
    "description": "Urgency, proximity, dormancy, manageability, controllability, detectability, interconnectivity, strategic impact, and propinquity."
  },
  {
    "id": 171,
    "topic_id": 4,
    "title": "What is integration testing?",
    "description": "Combining software modules and testing them as a group or as a whole."
  },
  {
    "id": 172,
    "topic_id": 1,
    "title": "This is the total, approved, expected cost for the project.",
    "description": "Cost baseline."
  },
  {
    "id": 173,
    "topic_id": 2,
    "title": "Describe the business analyst role.",
    "description": "They are responsible for gathering and documenting requirements for the project and facilitating the implementation of the requirements into the final product or result of the project."
  },
  {
    "id": 174,
    "topic_id": 1,
    "title": "What is NPV and how is it calculated?",
    "description": "Net preset value is a cash flow technique that takes into account the differences in the value of money over time by calculating the revenues or cash flows the organization expects to receive over the life of the project in today\u2019s dollars. The cash inflows for each year are converted to present value and then summed. The initial investment is subtracted from the sum of the present value cash flows to determine NPV."
  },
  {
    "id": 175,
    "topic_id": 1,
    "title": "What is the purpose of the change control log and what data does it usually display?",
    "description": "This log contains a list of all project changes and typically includes a unique identification number, date, description, requestor name, status, disposition, and implementation date."
  },
  {
    "id": 176,
    "topic_id": 1,
    "title": "Name two characteristics of agile teams.",
    "description": "They are self-organized and self-directed."
  },
  {
    "id": 177,
    "topic_id": 1,
    "title": "What is the formula for SPI?",
    "description": "SPI = EV / PV."
  },
  {
    "id": 178,
    "topic_id": 1,
    "title": "What do change impact assessments examine?",
    "description": "These are performed to determine if the change should be implemented, costs, benefits, effectiveness of the change, risk, impacts to other areas of the project, team skills, and ability to perform the change."
  },
  {
    "id": 179,
    "topic_id": 1,
    "title": "Name the five conflict resolution techniques.",
    "description": "Smoothing, forcing, compromise, collaborating, and avoiding."
  },
  {
    "id": 180,
    "topic_id": 4,
    "title": "What is an IT network?",
    "description": "This is a collection of devices connected to each other using cables or wireless communication to enable the sharing and exchange of data and services."
  },
  {
    "id": 181,
    "topic_id": 3,
    "title": "Performing this function on deliverables results in the WBS.",
    "description": "Decomposition."
  },
  {
    "id": 182,
    "topic_id": 4,
    "title": "What is a program manager?",
    "description": "They are responsible for overseeing the project management activities for all the projects that make up the program."
  },
  {
    "id": 183,
    "topic_id": 1,
    "title": "What\u2019s known as adding resources to the critical path to shorten project duration?",
    "description": "Crashing."
  },
  {
    "id": 184,
    "topic_id": 2,
    "title": "Name the negative risk response strategies.",
    "description": "Avoid, transfer, mitigate, and accept."
  },
  {
    "id": 185,
    "topic_id": 1,
    "title": "Describe situational/scenario-based risk analysis.",
    "description": "This looks at risk from the perspective of various situations or scenarios that may occur as the project progresses."
  },
  {
    "id": 186,
    "topic_id": 1,
    "title": "What comprises the performance measurement baseline?",
    "description": "Scope baseline, schedule baseline, and cost baseline."
  },
  {
    "id": 187,
    "topic_id": 1,
    "title": "Describe ROI and the formula to calculate it.",
    "description": "Return on investment measures the profitability of an investment and is often used to compare one investment to another. The formula is: (Current Value or Gain from the Investment \u2013 Cost of Investment) / Cost of the Investment. Projects with negative ROI should not proceed."
  },
  {
    "id": 188,
    "topic_id": 1,
    "title": "Describe pair programming and the agile methodology it\u2019s associated with.",
    "description": "Pair programming is a technique in the extreme programming (XP) methodology. It involves two developers sitting together at the same computer to write code. This improves quality of the code and may increase the speed at which code can be delivered."
  },
  {
    "id": 189,
    "topic_id": 1,
    "title": "What is end-to-end testing?",
    "description": "Testing the software or programming code from the beginning to the end."
  },
  {
    "id": 190,
    "topic_id": 1,
    "title": "Describe and give three examples of PII data.",
    "description": "Any information that can be used to distinguish or trace an individual\u2019s identity, including name, birth date, address, and more."
  },
  {
    "id": 191,
    "topic_id": 3,
    "title": "This term is known as relationships between tasks.",
    "description": "Dependencies."
  },
  {
    "id": 192,
    "topic_id": 1,
    "title": "What is the purpose of a sprint planning meeting?",
    "description": "This is a short, time-bound period of work where the product owner chooses items from the product backlog list to work on during the sprint."
  },
  {
    "id": 193,
    "topic_id": 1,
    "title": "What is a rollback plan and what is it also known as?",
    "description": "A rollback plan allows the IT team to roll back the system to the last known good state. It\u2019s also known as a regression plan or reverse changes."
  },
  {
    "id": 194,
    "topic_id": 1,
    "title": "What project document should be updated when a change is approved?",
    "description": "The project management plan."
  },
  {
    "id": 195,
    "topic_id": 1,
    "title": "Describe IRR.",
    "description": "Internal rate of return is the discount rate when the present value of the cash inflows equals the original investment."
  },
  {
    "id": 196,
    "topic_id": 2,
    "title": "What funding allocation is an amount of money set aside to deal with the cost of possible adverse events?",
    "description": "Contingency reserve."
  },
  {
    "id": 197,
    "topic_id": 2,
    "title": "What is an IT architect?",
    "description": "They are responsible for designing technology solutions and services for business applications, infrastructure, networks, storage, cloud solutions, security, and more. There are several types of architects, including infrastructure architects, enterprise architects, solutions architects, security architects, cloud architects, and more."
  },
  {
    "id": 198,
    "topic_id": 1,
    "title": "Describe regression testing.",
    "description": "Testing that\u2019s performed when changes are made to the code, after maintenance activities, or after software configurations are modified to ensure the software works the same way it did prior to the changes."
  },
  {
    "id": 199,
    "topic_id": 1,
    "title": "Define resource allocation.",
    "description": "This is identifying resource availability, skills sets, and availability, and assigning them to project tasks."
  },
  {
    "id": 200,
    "topic_id": 1,
    "title": "Name the three categories of contracts.",
    "description": "Fixed price, cost reimbursable, and time and materials."
  },
  {
    "id": 201,
    "topic_id": 1,
    "title": "Describe refactoring and the agile methodology it\u2019s associated with.",
    "description": "This is a technique in the extreme programming (XP) methodology. It involves improving the quality of the code without changing its functionality. It reduces duplication and eliminates poor code."
  },
  {
    "id": 202,
    "topic_id": 1,
    "title": "What type of project status report do executives prefer?",
    "description": "Dashboards."
  },
  {
    "id": 203,
    "topic_id": 1,
    "title": "What is the difference between a burndown and a burnup chart?",
    "description": "A burndown chart shows the remaining work of the iteration. A burnup chart starts at zero and shows the work completed during the iteration along with all of the work of the project."
  },
  {
    "id": 204,
    "topic_id": 1,
    "title": "Describe an IT developer or engineer.",
    "description": "The team members responsible for writing programming code, documenting code, developing applications, maintaining, and modifying applications, and more."
  },
  {
    "id": 205,
    "topic_id": 2,
    "title": "What is stress testing?",
    "description": "Testing software for dependability and stability under various load conditions. It examines processing and error handling capabilities."
  },
  {
    "id": 206,
    "topic_id": 1,
    "title": "Name the three elements of maintaining communication records.",
    "description": "Security, integrity, and archiving."
  },
  {
    "id": 207,
    "topic_id": 1,
    "title": "Why is communication security important on the project?",
    "description": "Project documents need to adhere to the organization\u2019s security policies and sensitive information should be guarded."
  },
  {
    "id": 208,
    "topic_id": 2,
    "title": "What is performance testing?",
    "description": "A type of stress test that looks for bottlenecks, slow response times, slow loading times, poor usage of memory, improper software configurations settings, and other issues that can cause performance to drag."
  },
  {
    "id": 209,
    "topic_id": 1,
    "title": "Describe a control chart.",
    "description": "This is used in quality control to measure and display sample variances of the same process over time. It is most commonly used in manufacturing."
  },
  {
    "id": 210,
    "topic_id": 2,
    "title": "Describe document integrity.",
    "description": "This ensures the document accurately reflects what the author intended and that others have not added, deleted, or altered the information."
  },
  {
    "id": 211,
    "topic_id": 1,
    "title": "What is a major characteristic of a matrix organization?",
    "description": "Matrix organizations are usually organized along department lines, but the project manager is responsible for assigning all project tasks to project team members."
  },
  {
    "id": 212,
    "topic_id": 2,
    "title": "Which conflict resolution technique is considered win-win and should be the technique used by project managers?",
    "description": "Collaboration."
  },
  {
    "id": 213,
    "topic_id": 1,
    "title": "What is rapid elasticity?",
    "description": "This is the ability to respond to a cloud consumers need for more (or less) memory, power, or storage on the cloud."
  },
  {
    "id": 214,
    "topic_id": 1,
    "title": "Describe document archiving.",
    "description": "This is a long-term storage option that allows you to reference archived project documents into the future."
  },
  {
    "id": 215,
    "topic_id": 1,
    "title": "Name the components of the communication exchange model.",
    "description": "Sender-message-receiver."
  },
  {
    "id": 216,
    "topic_id": 1,
    "title": "Describe a decision tree.",
    "description": "A diagram that shows the sequence of interrelated decisions and their expected results of choosing one alternative over another."
  },
  {
    "id": 217,
    "topic_id": 2,
    "title": "Describe the role of testers and QA in IT.",
    "description": "QA is used to ensure the requirements for the system or application are met and function as designed. The project team members, IT team members, and end users are all responsible for ensuring quality standards and criteria are met."
  },
  {
    "id": 218,
    "topic_id": 1,
    "title": "What is the stakeholder register?",
    "description": "A document that contains the names, contact information, roles, levels of influence, levels of interests, and more of the project\u2019s stakeholders."
  },
  {
    "id": 219,
    "topic_id": 3,
    "title": "What is a scatter diagram?",
    "description": "This is used in quality control and plots two numerical variables to determine if there is a correlation between them."
  },
  {
    "id": 220,
    "topic_id": 3,
    "title": "Define ETC.",
    "description": "ETC is estimate to complete and is the forecast of the cost of all the remaining project work. This figure is usually provided by the project team members."
  },
  {
    "id": 221,
    "topic_id": 2,
    "title": "What is stakeholder analysis?",
    "description": "Assessing the stakeholders\u2019 interests, level of influence, knowledge, contributions, and more."
  },
  {
    "id": 222,
    "topic_id": 1,
    "title": "What is current state vs. future state?",
    "description": "This is a performance analysis technique that examines projects and their potential impacts to the organization. The current state is examined and documented. The future state should how the benefits and improvement the project will have on the organization and documents the state the organization wants to be when the project is complete."
  },
  {
    "id": 223,
    "topic_id": 3,
    "title": "What step is performed to ensure a change meets the requirements of the change request?",
    "description": "Validating."
  },
  {
    "id": 224,
    "topic_id": 1,
    "title": "Describe how scope creep comes about.",
    "description": "Through uncontrolled changes, not following the change control process, and by submitting too many change requests."
  },
  {
    "id": 225,
    "topic_id": 2,
    "title": "Describe test-driven development and the agile methodology it\u2019s associated with.",
    "description": "This is a test-first approach in the extreme programming (XP) methodology. It involves rigorous testing of code, which provides significant, immediate feedback to the developers. These tests are combined with existing unit tests and run each time code is released. Tests must pass with no errors in every iteration."
  },
  {
    "id": 226,
    "topic_id": 1,
    "title": "What is a burndown chart in agile methodology?",
    "description": "A burndown chart shows the remaining work effort and time remaining for the iteration or for the project."
  },
  {
    "id": 227,
    "topic_id": 1,
    "title": "Name several types of organizational change.",
    "description": "Merger/acquisition, demerger/split, business process change, internal reorganization, relocation, and outsourcing."
  },
  {
    "id": 228,
    "topic_id": 1,
    "title": "Describe a master service agreement.",
    "description": "A governing agreement contract type that outlines the specifications of the overall engagement with pre-agreed upon terms for future changes."
  },
  {
    "id": 229,
    "topic_id": 1,
    "title": "Describe resource pooling as it relates to the cloud.",
    "description": "This allows the cloud provider to use the same resources to serve multiple consumers using a multi-tenant model."
  },
  {
    "id": 230,
    "topic_id": 1,
    "title": "Schedule revisions and impacts to the performance measurement baselines occur as a result of this.",
    "description": "Scope changes."
  },
  {
    "id": 231,
    "topic_id": 1,
    "title": "Describe a power/interest grid.",
    "description": "A grid used for stakeholder analysis. It uses two factors to identify the power, authority, interest, or influence level the stakeholder has on the project. They are most useful on small projects where it\u2019s easier to identify the relationship between the stakeholder and the project."
  },
  {
    "id": 232,
    "topic_id": 3,
    "title": "How are work package estimates derived?",
    "description": "By taking a cumulative total of all the schedule activities within the work package."
  },
  {
    "id": 233,
    "topic_id": 2,
    "title": "Describe the purpose for monitoring risks and the person who is responsible for this activity.",
    "description": "Monitoring risk is performed by the risk owner. It involves watching for risk triggers, implementing the risk response plan, tracking and monitoring identified risks, identifying and responding to new risks as they occur, and following the points of escalation when informing others of the risks."
  },
  {
    "id": 234,
    "topic_id": 1,
    "title": "Describe schedule compression.",
    "description": "This is a form of mathematical analysis used to shorten the project schedule without changing project scope."
  },
  {
    "id": 235,
    "topic_id": 1,
    "title": "What are historical data, former project documents, and documents such as prequalified vendor lists, preexisting contracts, and predetermine clients called?",
    "description": "Artifacts."
  },
  {
    "id": 236,
    "topic_id": 1,
    "title": "Describe the characteristics of the waterfall methodology.",
    "description": "This approach is completed in step-by-step fashion, and you cannot move to the next step or phase until the previous one is completed. Work cannot start until planning is finished."
  },
  {
    "id": 237,
    "topic_id": 2,
    "title": "Name the three common causes of variance.",
    "description": "Random variances, known or predictable variances, and variances always present in the process."
  },
  {
    "id": 238,
    "topic_id": 1,
    "title": "State a few examples of secondary storage.",
    "description": "This includes devices such as hard drives, flash drives, optical drives, DVDs, memory cards, virtual drives, and more. Secondary storage is also known as external memory."
  },
  {
    "id": 239,
    "topic_id": 2,
    "title": "What are discretionary dependencies?",
    "description": "Discretionary dependencies are usually based on best practices and are usually defined by the project team. They are also known as soft logic."
  },
  {
    "id": 240,
    "topic_id": 1,
    "title": "Name the steps involved with organizational change.",
    "description": "Define the change, communicate, analyze impacts and responses, training, ensure adoption over time, communicate during and after the change, document, create new knowledge bases, and create new processes."
  },
  {
    "id": 241,
    "topic_id": 1,
    "title": "What are prequalified vendors?",
    "description": "Prequalified vendor lists are prepared by the contract and procurement department in your organization. This is a list of vendors that have already been vetted by the organization and it includes goods, services, and prices for each of the vendors on the list."
  },
  {
    "id": 242,
    "topic_id": 1,
    "title": "Describe points of escalation as noted in the risk response plan.",
    "description": "This describes the people who should be notified when risk events occur and the order in which they should be notified. The project manager is almost always the first point of escalation."
  },
  {
    "id": 243,
    "topic_id": 1,
    "title": "Describe a salience model, including the three elements it uses.",
    "description": "This is used for stakeholder analysis. The model uses three elements: power, urgency, and legitimacy. Power is the ability to influence, urgency refers to the level of investment or impact the stakeholder has to the project, and legitimacy refers to the legitimate need to participate in or receive benefits from the project."
  },
  {
    "id": 244,
    "topic_id": 1,
    "title": "What happens to a negative risk once it occurs?",
    "description": "It becomes an issue and should be managed using the issue management process."
  },
  {
    "id": 245,
    "topic_id": 1,
    "title": "Which type of contract poses the most amount of risk to the seller?",
    "description": "Fixed-price."
  },
  {
    "id": 246,
    "topic_id": 1,
    "title": "What are the characteristics of the hybrid life cycle methodology?",
    "description": "This is a combination of waterfall and agile methodologies, or a combination of different agile methodologies. This is a good methodology to use to introduce a team to the principles of agile."
  },
  {
    "id": 247,
    "topic_id": 1,
    "title": "What is the formula used to calculate the lines of communication?",
    "description": "The formula is n (n \u2013 1) / 2."
  },
  {
    "id": 248,
    "topic_id": 2,
    "title": "Describe TOR.",
    "description": "TOR stands for terms of reference and is similar to a SOW used in the procurement process. The TOR is used for professional services contracts."
  },
  {
    "id": 249,
    "topic_id": 1,
    "title": "Describe a cost plus award fee contract.",
    "description": "A cost-reimbursable contract that includes an award fee paid when the work is completed. The award fee is at the discretion of the buyer."
  },
  {
    "id": 250,
    "topic_id": 1,
    "title": "Describe SPII and give a few examples of this type of data.",
    "description": "SPII is a subset of PII. SPII data elements on their own could identify an individual and cause them great harm or potential embarrassment if used inappropriately. Some examples include social security number, drivers license number, and financial account numbers."
  },
  {
    "id": 251,
    "topic_id": 1,
    "title": "Describe some examples of informal communications.",
    "description": "Phone calls, emails, hallway conversations, and impromptu meetings."
  },
  {
    "id": 252,
    "topic_id": 1,
    "title": "Describe the issue log.",
    "description": "A document where issues are tracked. It includes information such as an identification number, description, date, issue owner, priority ranking, urgency, resolution plan, and status."
  },
  {
    "id": 253,
    "topic_id": 1,
    "title": "Describe an IT security policy.",
    "description": "This is a document (or documents) that outlines the minimum standards required to secure the organization\u2019s technology related systems, assets, and data. It also outlines the rules and procedures for accessing the organization\u2019s systems and data."
  },
  {
    "id": 254,
    "topic_id": 1,
    "title": "What is the purpose of the preliminary scope statement?",
    "description": "It describes the objectives and the reason for the project including the business problem the project is trying to solve."
  },
  {
    "id": 255,
    "topic_id": 1,
    "title": "What are predetermined clients?",
    "description": "Partner companies that have been certified by a large organization to work with their product or service."
  },
  {
    "id": 256,
    "topic_id": 1,
    "title": "What does IT infrastructure control involve?",
    "description": "Changes to elements of the IT environment such as servers, firmware updates, software updates, and more."
  },
  {
    "id": 257,
    "topic_id": 2,
    "title": "Name the five core values of extreme programming.",
    "description": "Communication, simplicity, feedback, courage, and respect."
  },
  {
    "id": 258,
    "topic_id": 1,
    "title": "What is Scrumban?",
    "description": "An agile methodology that combines the practices of Scrum and Kanban."
  },
  {
    "id": 259,
    "topic_id": 1,
    "title": "Define crashing.",
    "description": "A project duration compression technique that weighs cost and schedule trade-offs."
  },
  {
    "id": 260,
    "topic_id": 1,
    "title": "Name the three environments used in development projects and/or when making changes to software code.",
    "description": "Development, beta-staging, and production."
  },
  {
    "id": 261,
    "topic_id": 3,
    "title": "This process formally reviews the project at specific points such as milestone completion or phase completion to determine whether the project should proceed.",
    "description": "Governance gates."
  },
  {
    "id": 262,
    "topic_id": 2,
    "title": "Describe a cost plus fixed fee contract.",
    "description": "A cost-reimbursable contract that includes adds a fixed fee that is paid upon completion of the contract."
  },
  {
    "id": 263,
    "topic_id": 1,
    "title": "What is structured data?",
    "description": "Data that is organized in meaningful ways so that it can be easily retrieved and modified. It is defined in a consistent manner, according to a predefined data model, and can be analyzed and processed by programs and systems."
  },
  {
    "id": 264,
    "topic_id": 1,
    "title": "Name the types of barriers a project manager might face when managing teams.",
    "description": "Time zones, geographic location, language and communication, cultural, technological, and personal preferences."
  },
  {
    "id": 265,
    "topic_id": 3,
    "title": "What are the three characteristics of objectives?",
    "description": "They should be clear, measurable, and actionable."
  },
  {
    "id": 266,
    "topic_id": 1,
    "title": "What is the life cycle of a record?",
    "description": "Creation, use, maintenance, and archival or disposal."
  },
  {
    "id": 267,
    "topic_id": 1,
    "title": "What are external dependencies?",
    "description": "Dependencies that are external to the project yet affect project activities."
  },
  {
    "id": 268,
    "topic_id": 1,
    "title": "What is a physical security policy?",
    "description": "This policy describes how to secure physical assets such as buildings, mobile devices, and removable media."
  },
  {
    "id": 269,
    "topic_id": 2,
    "title": "What are preexisting contracts?",
    "description": "These are active contracts in place in the organization that you can utilize to procure resources for your project. They can range from services contracts to materials contracts and more."
  },
  {
    "id": 270,
    "topic_id": 4,
    "title": "What is the five-step approach of the feature-driven development agile approach?",
    "description": "Develop a model, create a features list, plan based on features, design based on features, and build based on features."
  },
  {
    "id": 271,
    "topic_id": 1,
    "title": "What is root cause analysis used for?",
    "description": "To determine the true cause of an issue and to help determine the severity of the impact to the project or the organization. Root causes look beyond symptoms to find the real cause of the issue."
  },
  {
    "id": 272,
    "topic_id": 1,
    "title": "What is unstructured data?",
    "description": "Data that does not adhere to a data model. It doesn\u2019t have identifiable rules or structure and isn\u2019t easily stored or processed."
  },
  {
    "id": 273,
    "topic_id": 1,
    "title": "What is a mandatory dependency?",
    "description": "One that is inherent in the work being performed. They usually involve physical limitations. They are also known as hard logic."
  },
  {
    "id": 274,
    "topic_id": 2,
    "title": "What is the beta-staging environment used for in software development projects and/or software changes?",
    "description": "This is where code is tested."
  },
  {
    "id": 275,
    "topic_id": 3,
    "title": "What is a decision model and what are the two categories of decision models?",
    "description": "A formal method of project selection that helps selection committees decide among competing projects. The two categories of decision models are benefit measurement methods and constrained optimization methods. Benefit measurement methods include cost\u2013benefit analysis, scoring models, payback period, discounted cash flow, net present value, internal rate of return, and return on investment. Constrained optimization methods are mathematical models used in selecting among highly complex projects."
  },
  {
    "id": 276,
    "topic_id": 1,
    "title": "Describe branding restrictions.",
    "description": "These are a type of security for those who create products, intellectual property, or provide unique services. Branding typically involves a trademark, copyright, registered trademark, or patent pending."
  },
  {
    "id": 277,
    "topic_id": 1,
    "title": "What does an operational security policy cover?",
    "description": "The security standards for background and security clearances."
  },
  {
    "id": 278,
    "topic_id": 1,
    "title": "What is a records management plan?",
    "description": "This describes the policies and standards the organization will use to manage the life cycle of data and records."
  },
  {
    "id": 279,
    "topic_id": 2,
    "title": "Name several steps involved in the Closing phase.",
    "description": "Verification and validation, formal sign-off, transition plans, removing access, releasing project resources, closing out contracts, archiving documents, conducting lessons learned, holding a project closure meeting, writing the project closeout report, celebrating, and kicking off the warranty period."
  },
  {
    "id": 280,
    "topic_id": 4,
    "title": "Describe a cost plus incentive fee contract.",
    "description": "A cost-reimbursable contract that includes an incentive for meeting or exceeding performance criteria described in the contract."
  },
  {
    "id": 281,
    "topic_id": 1,
    "title": "This relates the OBS to the WBS so that every component of the work of the project is assigned to an individual.",
    "description": "Responsibility Assignment Matrix (RAM)."
  },
  {
    "id": 282,
    "topic_id": 1,
    "title": "Describe a procurement SOW.",
    "description": "It contains the details of the procurement item in clear, concise terms. It typically includes the project objectives, a description of work, specifications, and a project schedule or time frame."
  },
  {
    "id": 283,
    "topic_id": 1,
    "title": "Which agile methodology (developed in the mid-1990s as a software development methodology) is considered constraint driven?",
    "description": "Dynamic systems development method (DSDM). In this method, scope is prioritized to meet the cost, quality, and time frame constraints."
  },
  {
    "id": 284,
    "topic_id": 4,
    "title": "Describe some examples of formal communications.",
    "description": "Team status meetings, kickoff meetings, written status reports, and team-building sessions."
  },
  {
    "id": 285,
    "topic_id": 1,
    "title": "Name the activities required to properly manage stakeholder expectations.",
    "description": "This involves communicating, resolving issues, improving project performance by implementing change requests, and managing concerns."
  },
  {
    "id": 286,
    "topic_id": 1,
    "title": "Describe a cost plus percentage of cost contract.",
    "description": "A cost-reimbursable contract that includes a fee that\u2019s calculated as a percentage of the reimbursable costs."
  },
  {
    "id": 287,
    "topic_id": 1,
    "title": "Describe dedicated resources.",
    "description": "Resources that are fully committed to the project."
  },
  {
    "id": 288,
    "topic_id": 2,
    "title": "Describe a business merger.",
    "description": "A business merger is a type of organizational change. It occurs when two business entities decide to become one. Both business entities in the new organization have equal power and authority."
  },
  {
    "id": 289,
    "topic_id": 2,
    "title": "Describe a WAN.",
    "description": "A network that covers a larger area and may be used by businesses that have more than one location close geographic proximity."
  },
  {
    "id": 290,
    "topic_id": 1,
    "title": "Describe a phase gate review.",
    "description": "Phase gate reviews occur at predetermined points in the project such as at the end of each project phase (Initiating, Planning, or Executing), or once certain milestones or deliverables are achieved."
  },
  {
    "id": 291,
    "topic_id": 2,
    "title": "What does a digital security policy cover?",
    "description": "This contains the rules for providing access and permissions to digital assets."
  },
  {
    "id": 292,
    "topic_id": 2,
    "title": "What is a records management system?",
    "description": "A software system that manages records throughout their life cycle."
  },
  {
    "id": 293,
    "topic_id": 4,
    "title": "What is expert judgment?",
    "description": "This relies on the expertise of stakeholders, subject matter experts, or those who have previous experience to help in making decision about the project, or in selecting from among competing projects."
  },
  {
    "id": 294,
    "topic_id": 1,
    "title": "Describe Scrum of Scrums.",
    "description": "This is an agile framework that allows an organization to use the Scrum methodology for large, complex projects. This involves several Scrum teams that each work from their own backlog. Collectively, the teams make up one Scrum team and a representative from each team attends a daily standup for the Scrum of Scrums."
  },
  {
    "id": 295,
    "topic_id": 2,
    "title": "What are the some of the philosophies and benefits of the Agile Unified Process methodology?",
    "description": "Team members can work on their own, simplicity, agility by following agile processes, focus on high-value activities, tool independence, tailoring AUP to fit the organization, situationally specific."
  },
  {
    "id": 296,
    "topic_id": 4,
    "title": "Describe MFA.",
    "description": "Multifactor authentication is a process whereby the user must use two or more methods to verify their identity during the sign-in process. The first step typically involves entering a username and password."
  },
  {
    "id": 297,
    "topic_id": 2,
    "title": "Describe fast tracking.",
    "description": "Beginning two activities at the same time that were previously scheduled to start sequentially."
  },
  {
    "id": 298,
    "topic_id": 1,
    "title": "Describe the difference between a Kanban board and a Scrum board.",
    "description": "A Kanban board is capacity based and a Scrum board is velocity, or time based."
  },
  {
    "id": 299,
    "topic_id": 1,
    "title": "Describe Scaled Agile Framework.",
    "description": "SAFe uses a single Scrum team and they all share the same backlog, they collaborate with all team members, and the team is self-organized and self-managed. SAFe has several principles that are focused on using systems thinking, taking an economic view, decentralizing decision making, tapping into the intrinsic motivation of workers, and more."
  },
  {
    "id": 300,
    "topic_id": 3,
    "title": "When is the preliminary scope statement written?",
    "description": "After the business case and before the project charter."
  },
  {
    "id": 301,
    "topic_id": 4,
    "title": "Describe project success criteria.",
    "description": "These are used to determine whether the deliverables and the final product of the project are acceptable and satisfactory."
  },
  {
    "id": 302,
    "topic_id": 1,
    "title": "What is the definition of a record?",
    "description": "Data or documents used to conduct and perform business."
  },
  {
    "id": 303,
    "topic_id": 1,
    "title": "Name the process group in which stakeholders have the least amount of influence.",
    "description": "Closing."
  },
  {
    "id": 304,
    "topic_id": 1,
    "title": "Describe Disciplined Agile.",
    "description": "This is a framework that combines several agile best practices in order to help the organization transform to agile methodologies. It\u2019s a tailoring approach that combines the best of several agile methodologies to fit the organization\u2019s needs. It also includes information from functional areas of the business."
  },
  {
    "id": 305,
    "topic_id": 2,
    "title": "What are the benefits of combining agile technologies?",
    "description": "This will increase the effectiveness of the team and create a synergy that will exceed what any individual team member can contribute on their own."
  },
  {
    "id": 306,
    "topic_id": 4,
    "title": "Name at least five factors to consider when choosing methodologies.",
    "description": "Tolerance for change/flexibility, requirements, budget, schedule, environment factors, culture, developmental, industry standards."
  },
  {
    "id": 307,
    "topic_id": 1,
    "title": "Name the technique that accommodates resource availability by modifying activities within their float times.",
    "description": "Resource smoothing."
  },
  {
    "id": 308,
    "topic_id": 2,
    "title": "Describe a RACI chart.",
    "description": "A type of RAM chart that outlines the resources and their tasks and records if they are responsible, accountable, consulted or informed for the task."
  },
  {
    "id": 309,
    "topic_id": 1,
    "title": "What is PHI?",
    "description": "Personally identifiable health information, also known as protected health information."
  },
  {
    "id": 310,
    "topic_id": 1,
    "title": "Describe a JAD session.",
    "description": "Business users and application developers meet together to focus on the business need, or the problem they are trying to solve, and to create a deep understanding of the requirements among all team members. JAD sessions help improve quality and ensure the solution will solve the problem."
  },
  {
    "id": 311,
    "topic_id": 1,
    "title": "What is an issue?",
    "description": "Something that has occurred or is occurring on the project that can impact the outcomes."
  },
  {
    "id": 312,
    "topic_id": 2,
    "title": "Describe a data security policy.",
    "description": "Data security policies typically define access to data by roles and responsibilities and/or by data classification."
  },
  {
    "id": 313,
    "topic_id": 4,
    "title": "What is the purpose of classifying records?",
    "description": "To identify the type of record such as personnel data or health records, and to help inform the retention schedule."
  },
  {
    "id": 77,
    "topic_id": 1,
    "title": "In which project management life cycle phase is the project charter document created?",
    "description": "Initiating."
  },
  {
    "id": 314,
    "topic_id": 1,
    "title": "Describe the PRINCE2 project management methodology.",
    "description": "PRINCE2 stands for PRojects IN Controlled Environments. This is a project management methodology that divides up projects into small stages that are logically organized. PRINCE2 is a predictive or waterfall approach to project management that can be used for any size project in any industry."
  },
  {
    "id": 315,
    "topic_id": 1,
    "title": "What seating arrangements does the extreme programming methodology encourage for team members?",
    "description": "It encourages team members to be collocated in the same workspace."
  },
  {
    "id": 316,
    "topic_id": 1,
    "title": "When is waterfall a good choice as a methodology?",
    "description": "When the requirements are well understood, the project is low risk, and the project team is well established and stable."
  },
  {
    "id": 317,
    "topic_id": 2,
    "title": "State the difference between resource leveling and resource smoothing.",
    "description": "Resource leveling may change the critical path and delay the project completion date; resource smoothing modifies activities within their float and does not change the critical path or project end date."
  },
  {
    "id": 318,
    "topic_id": 2,
    "title": "Name the stages involved in the PRINCE2 methodology.",
    "description": "Startup or request, initiating, directing, controlling, delivering, stage boundaries, and closing."
  },
  {
    "id": 319,
    "topic_id": 1,
    "title": "Describe gap analysis.",
    "description": "This analysis determines the differences between the current state and the future, or desired state."
  },
  {
    "id": 320,
    "topic_id": 1,
    "title": "What is IaaS?",
    "description": "Infrastructure as a service (IaaS) is a software model that allows the cloud consumer to provision servers, storage, networking, operating systems, and other computing resources on demand."
  },
  {
    "id": 321,
    "topic_id": 1,
    "title": "What are story points?",
    "description": "Story points are used in an agile methodology and are any unit of measurement the team agrees upon. They are used to help determine activity duration estimates."
  },
  {
    "id": 322,
    "topic_id": 1,
    "title": "What are access controls used for?",
    "description": "To restrict access to systems, functions, data, and more."
  },
  {
    "id": 323,
    "topic_id": 1,
    "title": "Describe velocity.",
    "description": "Velocity is used in Scrum to determine how long it will take to complete the backlog. Velocity reflects the speed at which the team is working."
  },
  {
    "id": 324,
    "topic_id": 1,
    "title": "Describe agile release planning.",
    "description": "This is a process that can be used to accommodate large projects while using the agile methodology. This breaks the project down into releases. Each release has its own set of user stories."
  },
  {
    "id": 325,
    "topic_id": 2,
    "title": "What is data classification?",
    "description": "This is a way to describe data according to its sensitivity, type, and value to the organization."
  },
  {
    "id": 326,
    "topic_id": 1,
    "title": "What project management life cycle phase are deliverables produced and verified?",
    "description": "Executing."
  },
  {
    "id": 327,
    "topic_id": 4,
    "title": "When is agile a good choice as a methodology?",
    "description": "When active participation of stakeholders is required throughout the project, when there is uncertainty about the requirements, when the project is high risk, or when the project is being performed in a changing environment."
  },
  {
    "id": 328,
    "topic_id": 1,
    "title": "Name the documents that should be sent prior to and shortly after a status meeting.",
    "description": "Meeting agendas are sent before the meeting and meeting minutes are sent after the meeting."
  },
  {
    "id": 329,
    "topic_id": 1,
    "title": "What is one of the key principles in the <i>Agile Manifesto?</i>",
    "description": "Focus on the value to the customer."
  },
  {
    "id": 330,
    "topic_id": 1,
    "title": "What is a sprint?",
    "description": "Sprints are used in the Scrum methodology and are time-bound periods, usually two weeks, where the team works on user stories."
  },
  {
    "id": 331,
    "topic_id": 1,
    "title": "What is PaaS?",
    "description": "Platform as a service (PaaS) is a software model that allows application developers to build applications in the cloud."
  },
  {
    "id": 332,
    "topic_id": 2,
    "title": "Describe a Scrum board or task board.",
    "description": "A Scrum board, also known as a task board, is time bound and displays the work of the sprint (or project) visually starting with the user stories. The columns represent stages of work throughout the sprint."
  },
  {
    "id": 333,
    "topic_id": 1,
    "title": "What is need to know basis?",
    "description": "This involves relaying the least amount of information needed with those who have a need to know to perform a task or fulfill their job function."
  },
  {
    "id": 334,
    "topic_id": 1,
    "title": "Describe Kanban.",
    "description": "This is a lean scheduling agile methodology where work is balanced against available resources or available capacity for work. It\u2019s a pull-based concept where tasks progress from one state to another (on columns on the Kanban board for example), and a new task is pulled from the previous state. It\u2019s also considered an on-demand scheduling."
  },
  {
    "id": 335,
    "topic_id": 1,
    "title": "What is the principle of least privilege?",
    "description": "Granting access permission at the least level of access needed to perform the job."
  },
  {
    "id": 336,
    "topic_id": 1,
    "title": "Describe a unit price contract.",
    "description": "This contract is priced according to the units of work that make up the project or materials needed to complete the work, or both. Rather than price the project as a whole, each unit of work has a price, and the contractor is paid when that unit of work is delivered."
  },
  {
    "id": 337,
    "topic_id": 4,
    "title": "Describe Kaizen.",
    "description": "Kaizen is a lean methodology that means continuous improvement. The foundational belief of Kaizen is that everything can be improved. This involves every person in the organization looking for ways to improve productivity and decrease the seven wastes."
  },
  {
    "id": 338,
    "topic_id": 2,
    "title": "Describe a meeting agenda and one of the elements that each agenda item should contain.",
    "description": "Agenda meetings outline the purpose for the meeting, the topics that will be covered, and who is presenting. Agenda topics should be timeboxed to help keep the meeting on track."
  },
  {
    "id": 21,
    "topic_id": 3,
    "title": "What are the two keys to a successful rewards and recognition program?",
    "description": "That rewards and recognition are applied consistently and that the reward or recognition is appropriate for the level of effort expended or the results achieved."
  },
  {
    "id": 339,
    "topic_id": 1,
    "title": "What is SaaS?",
    "description": "Software as a service (SaaS) is a model whereby a cloud consumer can access application(s) on demand that have been developed and run on a cloud infrastructure."
  },
  {
    "id": 340,
    "topic_id": 1,
    "title": "Name some common roles for meetings.",
    "description": "A facilitator who manages the meeting, a scribe who takes meeting notes, and attendees."
  },
  {
    "id": 341,
    "topic_id": 1,
    "title": "What is timeboxing?",
    "description": "Setting time limits on meetings, agenda items, daily standups, and sprints."
  },
  {
    "id": 342,
    "topic_id": 1,
    "title": "What is CapEx?",
    "description": "Expenses related to capital assets that are expected to provide value to the organization into the future."
  },
  {
    "id": 343,
    "topic_id": 2,
    "title": "What does the principle of least privilege help protect against?",
    "description": "Cyberattacks."
  },
  {
    "id": 344,
    "topic_id": 1,
    "title": "Name the project management life cycle phase where the schedule, resources, requirements, communication strategies, and budget are developed.",
    "description": "Planning."
  },
  {
    "id": 345,
    "topic_id": 1,
    "title": "Describe a Kanban board.",
    "description": "The Kanban board has columns that represent stages of work, and cards which represent units of work that are moved from stage to stage as resources become available. The team can visually see the stages of work and where bottlenecks in the process are occurring."
  },
  {
    "id": 346,
    "topic_id": 1,
    "title": "When should you consider using a hybrid development methodology?",
    "description": "Use this approach when the team is new to agile, when there is uncertainty or complexity, or when there are uncertain risks about the project requirements."
  },
  {
    "id": 347,
    "topic_id": 2,
    "title": "Describe a weighted scoring model.",
    "description": "This is a vendor selection technique that evaluates vendors based on predetermined criteria. Each criterion is assigned a weight and each vendor is assigned a score that is multiplied by the weight to determine the final score for that criterion. All scores are added at the end of the evaluation to come up with a final score. The vendor with the highest score is the one you should select."
  },
  {
    "id": 348,
    "topic_id": 1,
    "title": "What are action items?",
    "description": "Action items are tasks or other actions that are assigned to an owner and need to be addressed by their designated due date."
  },
  {
    "id": 349,
    "topic_id": 1,
    "title": "What is the purpose of the project kickoff meeting and when does it occur?",
    "description": "The purpose is to ensure the stakeholders and team members are aware and understand the objectives of the project. It can be held after the project charter is signed and published and/or in the executing life cycle phase once all team members are assigned. It is acceptable to hold two kickoff meetings if needed, one after the charter is signed and the other once all team members are assigned."
  },
  {
    "id": 350,
    "topic_id": 1,
    "title": "Describe buffers as they relate to project schedules.",
    "description": "Buffers, also known as contingency reserves, are used at milestone dates on the project schedule to add a certain amount of non-work-related time to account for risk or unforeseen events."
  },
  {
    "id": 351,
    "topic_id": 1,
    "title": "What is an epic used for in agile methodologies?",
    "description": "Epics are placeholders that are used to capture big ideas, features, or functionality that are not fully formed. Epics are placed in the backlog and broken down into user stories as more information becomes known about the feature or function."
  },
  {
    "id": 352,
    "topic_id": 1,
    "title": "What is OpEx?",
    "description": "Expenses associated with performing the normal, day-to-day activities of managing a business such as rent, payroll, office supplies, and more."
  },
  {
    "id": 353,
    "topic_id": 1,
    "title": "What is a communication platform?",
    "description": "It provides a way for the project team members to connect in real time with one another."
  },
  {
    "id": 354,
    "topic_id": 1,
    "title": "Name some of the agenda items that should be covered during the kickoff meeting.",
    "description": "Welcome, introductions, introduce the sponsor and key stakeholders, project overview, stakeholder expectations, roles and responsibilities, and question and answer."
  },
  {
    "id": 355,
    "topic_id": 4,
    "title": "What is the most important activity a project manager can perform on any project?",
    "description": "Communicating."
  },
  {
    "id": 356,
    "topic_id": 1,
    "title": "What are the triple constraints?",
    "description": "Scope, time, and budget."
  },
  {
    "id": 357,
    "topic_id": 1,
    "title": "Name at least three vendor evaluation techniques.",
    "description": "Best value versus lowest cost, cost\u2013benefit analysis, market research, competitive analysis, qualifications, prequalified vendors/sellers, demonstration, technical approach, physical and financial capacity, and references."
  },
  {
    "id": 358,
    "topic_id": 1,
    "title": "What collaboration tools might help with requirements gathering or brainstorming during a project meeting?",
    "description": "Multi-authoring and editing software and whiteboards."
  },
  {
    "id": 359,
    "topic_id": 1,
    "title": "Describe a wiki knowledge base.",
    "description": "A collaboration tool that contains project documents and information and that allows project team members to create, add, and update content."
  },
  {
    "id": 360,
    "topic_id": 2,
    "title": "What is a solutions architect?",
    "description": "The person responsible for finding the technical solution that will best solve the business problem and then implementing it. They determine the solution and work closely with the enterprise architect, the business team, and the project manager to implement the solution. They must be well versed in all aspects of IT."
  },
  {
    "id": 361,
    "topic_id": 2,
    "title": "Describe on-demand scheduling, also known as pull-based scheduling.",
    "description": "Kanban is an on-demand scheduling methodology whereby work is pulled on-demand, as resources have capacity to work."
  },
  {
    "id": 362,
    "topic_id": 2,
    "title": "Describe expenditure tracking.",
    "description": "This includes measuring the project spending to date, determining the burn rate, and tracking expenditures to the cost baseline so that stakeholders can see what was planned versus what was actually spent on the project."
  },
  {
    "id": 363,
    "topic_id": 1,
    "title": "What collaboration tool helps to automate document routing for reviews and signatures?",
    "description": "Workflow and e-signature platforms."
  },
  {
    "id": 364,
    "topic_id": 1,
    "title": "In which order are the three documents in the initiating project management life cycle phase written?",
    "description": "The business case, preliminary scope statement, and project charter."
  },
  {
    "id": 365,
    "topic_id": 200,
    "title": "Be able to define a project.",
    "description": "A project brings about a unique product, service, or result and has definite beginning and ending dates."
  },
  {
    "id": 366,
    "topic_id": 200,
    "title": "Be able to identify the difference between a project and ongoing operations.",
    "description": "A project is a temporary endeavor to create a unique product or service. Operational work is ongoing and repetitive."
  },
  {
    "id": 367,
    "topic_id": 200,
    "title": "Be able to define a program and a portfolio.",
    "description": "A program is a group of related projects managed to gain benefits that couldn't be realized if they were managed independently. Portfolios are collections of programs and projects that support strategic business goals or objectives. Programs and projects within the portfolio may not be related to one another."
  },
  {
    "id": 368,
    "topic_id": 200,
    "title": "Be able to name the life cycle phases of a project and their primary purpose.",
    "description": "The phases are Discovery/Concept, Initiating, Planning, Executing, and Closing. Discovery is where the business case is created and the project is justified. Initiating is where the preliminary scope statement and project charter are created. Planning consists of preparing for the work of the project. Executing is where the work of the project is performed, monitored, and tracked. Closing is where project closeout occurs and contracts are closed, team members released, and more."
  },
  {
    "id": 369,
    "topic_id": 200,
    "title": "Understand the needs and demands that bring about a project.",
    "description": "The needs and demands that bring about a project include market demand, organizational need, customer request, technological advance, legal requirement, ecological impacts, and social need."
  },
  {
    "id": 370,
    "topic_id": 200,
    "title": "Understand the purpose of a business case.",
    "description": "A business case documents the business need for the project and determines whether the investment in the project is worthwhile."
  },
  {
    "id": 371,
    "topic_id": 200,
    "title": "Be able to describe the two steps involved in validating a project.",
    "description": "Validating a project involves writing and reviewing the business case and analyzing the stakeholders."
  },
  {
    "id": 372,
    "topic_id": 200,
    "title": "Be able to identify commonly used business case justification and project selection methods.",
    "description": "The most common project selection methods are cost\u2010benefit analysis, scoring model, payback period, discounted cash flow, net present value, return on investment, internal rate of return, and current state versus future state Understand what skills are needed to manage a project beyond technical knowledge of the product."
  },
  {
    "id": 373,
    "topic_id": 200,
    "title": "Be able to define the role of a project manager.",
    "description": "A project manager's core function is project integration. A project manager leads the project team and oversees all the work required to complete the project goals to the satisfaction of the stakeholders."
  },
  {
    "id": 374,
    "topic_id": 200,
    "title": "Understand what skills are needed to manage a project beyond technical knowledge of the product.",
    "description": "Key general management skills include leadership, communication, problem\u2010solving, negotiation, organization, and time management."
  },
  {
    "id": 375,
    "topic_id": 200,
    "title": "Be able to define ESG factors that influence project management activities.",
    "description": "ESG stands for environmental, social, and governance factors that may influence project management activities. Compliance and privacy considerations as well as legal and regulatory requirements are part of ESG factors."
  },
  {
    "id": 376,
    "topic_id": 200,
    "title": "Be able to define PII and SPII data.",
    "description": "PII is personally identifiable information that may be used to distinguish or trace an individual's identity. SPII data is a subset of PII and on its own has the potential to cause harm, inconvenience, embarrass, or cause harm to an individual's reputation. PII data becomes SPII data when it's linked with SPII data. PHI is personal health information and is a form of PII."
  },
  {
    "id": 377,
    "topic_id": 200,
    "title": "Understand legal and regulatory impacts.",
    "description": "Legal and regulatory impacts must be defined and accounted for when performing project management. Make certain to ask subject matter experts in your organization about these requirements for your project. Don't forget industry\u2010specific regulations or those related to information technology projects."
  },
  {
    "id": 378,
    "topic_id": 200,
    "title": "Be able to define information technology.",
    "description": "IT involves the use of computers and computer networks to create, store, process, and transmit electronic information."
  },
  {
    "id": 379,
    "topic_id": 200,
    "title": "Be able to define IT infrastructure.",
    "description": "Infrastructure consists of all the hardware, software, servers, networks, data centers, and more that comprise and support IT activities for an organization. Infrastructure enables the organization to provide IT services to its employees and customers."
  },
  {
    "id": 380,
    "topic_id": 200,
    "title": "Understand the two most common types of computer networks.",
    "description": "A computer network is the collection of devices connected to each other using cables or wireless communication to enable the sharing and exchange of data and services. A LAN is a local area network used in a specific location such as a school or a business. The LAN connects the technology and devices used by the organization to each other so they can share information, utilize software and services, and communicate with each other. A WAN is a network that covers a larger area and may be used by businesses that have more than one location."
  },
  {
    "id": 381,
    "topic_id": 200,
    "title": "Be able to describe computer storage.",
    "description": "Computer storage is a hardware device where digital data and content are stored and accessed by users or programs. It consists of primary storage, also known as internal memory, such as RAM and ROM; and secondary storage, also known as external memory, such as hard drives, flash drives, memory cards, and more."
  },
  {
    "id": 382,
    "topic_id": 200,
    "title": "Be able to define a data warehouse.",
    "description": "A data warehouse is a system that collects, organizes, centralizes, and manages data that is used and analyzed by managers and executives to make decisions about the business."
  },
  {
    "id": 383,
    "topic_id": 200,
    "title": "Understand cloud computing.",
    "description": "Cloud computing allows for the sharing of software, information, data, and services to computers and technology devices on demand."
  },
  {
    "id": 384,
    "topic_id": 200,
    "title": "Understand cloud service models.",
    "description": "There are four primary cloud service models: SaaS, PaaS, IaaS, and XaaS."
  },
  {
    "id": 385,
    "topic_id": 200,
    "title": "Be able to name four software systems common to IT.",
    "description": "Four systems are ERP, CRM, EDRMS, and CMS."
  },
  {
    "id": 386,
    "topic_id": 200,
    "title": "Be able to define project stakeholders.",
    "description": "A stakeholder is anyone who has a vested interest in the project and has something to gain or lose from the project. Stakeholders include the sponsor, project manager, project team members, functional managers, customers, team members, and others with an interest in the project."
  },
  {
    "id": 387,
    "topic_id": 200,
    "title": "Be able to define a project manager.",
    "description": "The project manager manages the team, communication, scope, risk, budget, and time. They also manage quality assurance and are responsible for the project artifacts."
  },
  {
    "id": 388,
    "topic_id": 200,
    "title": "Be able to define a project sponsor.",
    "description": "A project sponsor is an executive in the organization who has the authority to allocate dollars and resources to the project. The sponsor approves funding, the project charter, the project baseline, and high\u2010level requirements. They have final decision\u2010making authority for the project, help with marketing the benefits of the project, remove roadblocks for the team, and participate in business case justification."
  },
  {
    "id": 389,
    "topic_id": 200,
    "title": "Be able to define a business analyst's role on the project.",
    "description": "A business analyst interviews stakeholders to gather and document requirements for the project. They also help implement the requirements into the final product, service, or result of the project."
  },
  {
    "id": 390,
    "topic_id": 200,
    "title": "Be able to define an SME.",
    "description": "The subject matter experts have specific knowledge and skills in their line of business. They contribute expertise to the project, work on deliverables, estimate task durations, estimate costs, estimate dependencies, and more."
  },
  {
    "id": 391,
    "topic_id": 200,
    "title": "Be able to define an end user.",
    "description": "The end users are the people who will use the software or services produced by the project. They may be internal or external to the organization and may also be customers."
  },
  {
    "id": 392,
    "topic_id": 200,
    "title": "Be able to define the project management office.",
    "description": "The PMO provides guidance to project managers and helps present a consistent, reliable approach to managing projects across the organization. PMOs are responsible for maintaining standards, processes, procedures, and templates. The program manager typically works in the PMO and has responsibility for overseeing all of the projects within their program."
  },
  {
    "id": 393,
    "topic_id": 200,
    "title": "Be able to define the IT team.",
    "description": "The IT team consists of the IT architect, developers, and testing/QA specialists. The architect is responsible for designing technology solutions and services for business applications, infrastructure networks storage, cloud, security and more. The developers write programming code, develop applications, and maintain and modify existing applications. The testing/QA specialists ensure that the application functions according to the requirements."
  },
  {
    "id": 394,
    "topic_id": 200,
    "title": "Know how to identify and analyze stakeholders.",
    "description": "The project manager should identify the project stakeholders, assess their influence and level of involvement, determine their needs and interests, and record stakeholder information in the stakeholder register."
  },
  {
    "id": 395,
    "topic_id": 200,
    "title": "Understand the ways to categorize and display stakeholder analysis.",
    "description": "Categorizing and displaying stakeholder analysis can take several forms, including power/interest grid, power/influence grid, impact/influence grid, stakeholder cube, the Salience model, and prioritization."
  },
  {
    "id": 396,
    "topic_id": 200,
    "title": "Understand the purpose for the preliminary scope statement.",
    "description": "The preliminary scope statement describes the objectives of the project and documents the business problem the project is attempting to solve."
  },
  {
    "id": 397,
    "topic_id": 200,
    "title": "Be able to describe a project charter and list the key components.",
    "description": "A project charter provides formal approval for the project to begin and authorizes the project manager to apply resources to the project. The key components are the purpose or justification for the project, project goals and objectives, project description, key deliverables, high\u2010level list of requirements, high\u2010level milestones, high\u2010level budget, high\u2010level assumptions, high\u2010level constraints, high\u2010level list of risks, name of the sponsor, name of the project manager, and criteria for project approval."
  },
  {
    "id": 398,
    "topic_id": 200,
    "title": "Be able to define success criteria for a project.",
    "description": "Success criteria are used to determine whether the deliverables and final outcomes of the project are acceptable and satisfactory to the stakeholders."
  },
  {
    "id": 399,
    "topic_id": 200,
    "title": "Describe the purpose of a records management system.",
    "description": "This is a system that manages the life cycle functionality of a record, starting with creation, use, maintenance, and archival or disposal."
  },
  {
    "id": 400,
    "topic_id": 200,
    "title": "Understand access controls and the principle of least access.",
    "description": "Access controls restrict access to systems, functions, data, and more. Access controls are applied to both humans and computing systems. The principle of least privilege is a matter of assigning the least amount of privilege needed to perform the job."
  },
  {
    "id": 401,
    "topic_id": 200,
    "title": "Understand the purpose of a kickoff meeting.",
    "description": "This meeting should include the sponsor, key project team members, and the key stakeholders. The goal is to make certain stakeholders understand the purpose and objectives of the project, and to understand their role in the project. Be sure to publish an agenda ahead of time and make time for questions and answers at the end of the meeting."
  },
  {
    "id": 402,
    "topic_id": 200,
    "title": "Understand the purpose of the scope statement.",
    "description": "The scope statement is the basis of the agreement between the project team and the customer concerning what comprises the work of the project. It defines the deliverables and success criteria that will meet those objectives."
  },
  {
    "id": 403,
    "topic_id": 200,
    "title": "Be able to list the components of a scope statement.",
    "description": "A scope statement includes a project description, acceptance criteria, key deliverables, exclusions from scope, assumptions, and constraints. It could also contain a high\u2010level time and cost estimate to complete the project."
  },
  {
    "id": 404,
    "topic_id": 200,
    "title": "Be able to define requirements.",
    "description": "Requirements describe the characteristics of the deliverables, or functionality that a deliverable must have, or specific conditions a deliverable must meet to satisfy the objective of the project."
  },
  {
    "id": 405,
    "topic_id": 200,
    "title": "Be able to define project constraints and assumptions.",
    "description": "Project constraints limit the options of the project team and restrict their actions. Sometimes constraints dictate actions. Time, budget, and scope are the most common constraints. Assumptions are conditions that are presumed to be true or real. They are both documented in the assumption log."
  },
  {
    "id": 406,
    "topic_id": 200,
    "title": "Be able to describe the PRINCE2 methodology.",
    "description": "PRINCE2 is a project management methodology that can be used for any size project in any industry. It manages the project in stages, step by step, to keep the project in control."
  },
  {
    "id": 407,
    "topic_id": 200,
    "title": "Understand the concept of the DevOps and DevSecOps framework.",
    "description": "DevOps combines the development team and operations team into one team to improve collaboration, communication, and deliver products more efficiently. DevSecOps adds security responsibilities to the team to deliver projects with fidelity."
  },
  {
    "id": 408,
    "topic_id": 200,
    "title": "Be able to describe SDLC.",
    "description": "The software development life cycle (SDLC) consists of phases such as planning, defining, designing, building, testing, and deploying. Waterfall and agile are types of SDLC methodologies."
  },
  {
    "id": 409,
    "topic_id": 200,
    "title": "Be able to name three types of development life cycles.",
    "description": "They are waterfall, agile, and hybrid."
  },
  {
    "id": 410,
    "topic_id": 200,
    "title": "Understand the hybrid development life cycle.",
    "description": "Hybrid is a combination of aspects of waterfall and agile, or a combination of multiple agile methodologies."
  },
  {
    "id": 411,
    "topic_id": 200,
    "title": "Be able to describe the agile project management methodology.",
    "description": "A method of managing projects in small, incremental portions of work that can be easily assigned, easily managed, and completed within a short period of time. Agile involves continuous stakeholder involvement and feedback."
  },
  {
    "id": 412,
    "topic_id": 200,
    "title": "Be able to describe the difference between Scrum and Kanban.",
    "description": "Scrum and Kanban are both agile methodologies. Scrum teams complete work in short, time\u2010bound periods called sprints. Kanban is a continuous system. The work does not start and stop but continues through to completion. Kanban is also known as an on\u2010demand scheduling system. Both Scrum and Kanban are known as pull systems."
  },
  {
    "id": 413,
    "topic_id": 200,
    "title": "Be able to name the key roles on a Scrum team.",
    "description": "The key roles are the product owner (also known as the voice of the customer), the Scrum team members, and the Scrum master."
  },
  {
    "id": 414,
    "topic_id": 200,
    "title": "Be able to describe a minimum viable product.",
    "description": "The minimum viable product involves breaking down tasks into tangible components that have enough features and functionality to allow the customer to examine value and provide feedback to the team. They are often prototypes or mock\u2010ups."
  },
  {
    "id": 415,
    "topic_id": 200,
    "title": "Be able to describe the product backlog.",
    "description": "The product backlog is a list of all the user stories that are needed to complete the project."
  },
  {
    "id": 416,
    "topic_id": 200,
    "title": "Be able to name several agile methodologies.",
    "description": "Examples are Extreme Programming, Scrumban, feature\u2010driven development, dynamic systems development method, and Agile Unified Process."
  },
  {
    "id": 417,
    "topic_id": 200,
    "title": "Understand the role of the solutions architect in solutions design.",
    "description": "Solutions design is determining the best technical solution for the business problem at hand. The solutions architect is the person determining the solution and works closely with the enterprise architect, the business team, and the project manager to implement the solution."
  },
  {
    "id": 418,
    "topic_id": 200,
    "title": "Know how to define and create a work breakdown structure.",
    "description": "The WBS is a deliverable\u2010oriented hierarchy that describes the work required to complete the project. The WBS is a multilevel diagram that starts with the project, includes the major deliverables, and decomposes the major deliverables into smaller units of work to the point where time and cost estimates can be provided and resources assigned."
  },
  {
    "id": 419,
    "topic_id": 200,
    "title": "Understand the levels in a WBS.",
    "description": "The highest level of the WBS is the project name. The major deliverables, project phases, or subprojects make up the next level. The number of levels in a WBS will vary by project; however, the lowest level of the WBS is a work package."
  },
  {
    "id": 420,
    "topic_id": 200,
    "title": "Describe a WBS dictionary.",
    "description": "The WBS dictionary describes each of the deliverables and their components and includes a code of accounts identifier, estimates, resources, criteria for acceptance, and any other information that helps clarify the deliverables."
  },
  {
    "id": 421,
    "topic_id": 200,
    "title": "Know the difference between analogous estimating and bottom\u2010up estimating.",
    "description": "Analogous estimating is a top\u2010down technique that uses expert judgment and historical information. Bottom\u2010up estimating performs estimates for each work item and rolls them up to a total."
  },
  {
    "id": 422,
    "topic_id": 200,
    "title": "Describe the task sequencing process.",
    "description": "Sequencing is the process of identifying dependency relationships between the project activities and scheduling activities in the proper order."
  },
  {
    "id": 423,
    "topic_id": 200,
    "title": "Name the two major relationships between dependent tasks.",
    "description": "A predecessor is a task that exists on a path with another task and occurs before the task in question. A successor is a task that exists on a common path with another task and occurs after the task in question."
  },
  {
    "id": 424,
    "topic_id": 200,
    "title": "Name the four types of logical relationships.",
    "description": "The four types of logical relationships are finish\u2010to\u2010start, start\u2010to\u2010start, start\u2010to\u2010finish, and finish\u2010to\u2010finish."
  },
  {
    "id": 425,
    "topic_id": 200,
    "title": "Know and understand the three most commonly used techniques to estimate activity duration.",
    "description": "Expert judgment relies on the knowledge of someone familiar with the tasks. Analogous or top\u2010down estimating bases the estimate on similar activities from a previous project. Parametric estimates are quantitatively\u2010based estimates that typically calculate the rate times the quantity."
  },
  {
    "id": 426,
    "topic_id": 200,
    "title": "Be able to calculate the critical path.",
    "description": "The critical path includes the activities with durations that add up to the longest path of the project schedule network diagram. This path controls the finish date of the project. Any delay to a critical path task will delay the completion date of the project."
  },
  {
    "id": 427,
    "topic_id": 200,
    "title": "Be able to define a critical path task.",
    "description": "A critical path task is a project activity with zero or negative float."
  },
  {
    "id": 428,
    "topic_id": 200,
    "title": "Define the purpose of CPM.",
    "description": "CPM calculates the longest full path in the project. This path controls the finish date of the project. Any delay to a critical path task will delay the completion date of the project."
  },
  {
    "id": 429,
    "topic_id": 200,
    "title": "Explain a network diagram.",
    "description": "A network diagram is used to depict project activities and the interrelationships and dependencies among these activities."
  },
  {
    "id": 430,
    "topic_id": 200,
    "title": "Name three common ways project schedules are displayed.",
    "description": "Project schedules are typically displayed as milestone charts, PERT network diagrams, or Gantt charts; a Gantt chart is a type of bar chart."
  },
  {
    "id": 431,
    "topic_id": 200,
    "title": "Be able to describe the difference between resource leveling and resource smoothing.",
    "description": "Resource leveling can change the critical path and project end date. Resource smoothing does not change the critical path or project end date."
  },
  {
    "id": 432,
    "topic_id": 200,
    "title": "Be familiar with the duration compression techniques.",
    "description": "The duration compression techniques are crashing and fast tracking."
  },
  {
    "id": 433,
    "topic_id": 200,
    "title": "Understand the estimating techniques for an agile project.",
    "description": "Expert judgment is used most frequently on agile projects, but other techniques such as parametric estimating or bottom\u2010up estimating will also work."
  },
  {
    "id": 434,
    "topic_id": 200,
    "title": "Understand how to determine activity durations for an agile project.",
    "description": "Activity durations can be calculated using the number of iterations needed to complete the work, using the number of story points needed to complete the work, or using average velocity to determine how many story points can be completed in each iteration."
  },
  {
    "id": 435,
    "topic_id": 200,
    "title": "Be able to describe a Kanban board and a Scrum board and the difference between them.",
    "description": "Kanban boards and Scrum boards are visual displays of the work of the project. Kanban uses cards or tasks, and Scrum uses tasks. Tasks are added to the first column, usually the backlog or user story column, and then broken down into tasks and pulled into the remaining columns as the work finishes. Kanban boards and their work are capacity\u2010bound. The work is progressive and continuous. There isn't a start and stop date. Scrum boards are time\u2010bound and display the work of the sprint."
  },
  {
    "id": 436,
    "topic_id": 200,
    "title": "Name the three types of organizational structures.",
    "description": "The three types of organizational structures are functional, matrix, and projectized structures. Matrix organizations may be structured as a strong matrix, weak matrix, or balanced matrix organization."
  },
  {
    "id": 437,
    "topic_id": 200,
    "title": "Understand the definition of resources.",
    "description": "Resources can be human resources or physical resources. They are used to complete the work of the project. Resources include human, physical, capital, shared resources, dedicated resources, low\u2010quality resources, internal resources, external resources, benched resources, and remote resources."
  },
  {
    "id": 438,
    "topic_id": 200,
    "title": "Define resource allocation.",
    "description": "Resource allocation is identifying resource availability and skills sets and assigning them to project tasks."
  },
  {
    "id": 439,
    "topic_id": 200,
    "title": "Define resource overallocation and resource shortage.",
    "description": "Resource overallocation occurs when resources are assigned too many tasks within a given time frame. Resource shortage occurs when there are not enough resources with the required skills or abilities to complete the tasks."
  },
  {
    "id": 440,
    "topic_id": 200,
    "title": "Define interproject dependencies and interproject resource contention.",
    "description": "Interproject dependencies occur when one project must complete its deliverables before another project can begin. Interproject resource contention occurs when resources are assigned to more than one project, resulting in timing and availability conflict."
  },
  {
    "id": 441,
    "topic_id": 200,
    "title": "Describe a RACI chart and define the acronym.",
    "description": "This is a matrix\u2010based chart that shows the resource role and responsibility level for the work product. RACI stands for responsible, accountable, consulted, and informed."
  },
  {
    "id": 442,
    "topic_id": 200,
    "title": "Name the five stages of team development.",
    "description": "They are forming, storming, norming, performing, and adjourning."
  },
  {
    "id": 443,
    "topic_id": 200,
    "title": "Describe team building and trust building.",
    "description": "Team building consists of activities that help diverse groups of people work together in an efficient and effective manner. Trust building involves building trust with the project manager and among team members. This takes time and is accomplished by being true to your word and having the team's best interests at heart."
  },
  {
    "id": 444,
    "topic_id": 200,
    "title": "Name the conflict\u2010resolution techniques and the technique that is best for project managers.",
    "description": "The techniques are smoothing, forcing, compromising, collaborating, and avoiding. Project managers should use the collaborating technique."
  },
  {
    "id": 445,
    "topic_id": 200,
    "title": "State the purpose of a project kickoff meeting.",
    "description": "The project kickoff meeting is a way to formally introduce all project team members, to review the goals and the deliverables for the project, to discuss roles and responsibilities, and to review stakeholder expectations."
  },
  {
    "id": 446,
    "topic_id": 200,
    "title": "Be able to name the types of contracts.",
    "description": "The contract types include fixed\u2010price, cost\u2010reimbursable, and time and materials."
  },
  {
    "id": 447,
    "topic_id": 200,
    "title": "Be able to name the types of vendor\u2010centric documents.",
    "description": "The types of vendor documents include nondisclosure agreements, cease\u2010and\u2010desist letters, letters of intent, statements of work, memoranda of understanding, service level agreements, purchase orders, maintenance agreements, and warranties."
  },
  {
    "id": 448,
    "topic_id": 200,
    "title": "Be able to name the type of contract that's best for an agile project.",
    "description": "A master service agreement (MSA) is the best type of contract to use for an agile project. Agile projects involve frequent, small deliveries, and an MSA allows you to add work to the contract via an appendix without having to rewrite the contract."
  },
  {
    "id": 449,
    "topic_id": 200,
    "title": "Describe a security policy.",
    "description": "A security policy defines the minimum standards required to secure the organization's assets and outlines the rules and procedures for accessing them."
  },
  {
    "id": 450,
    "topic_id": 200,
    "title": "Be able to name three types of devices covered in a physical security policy.",
    "description": "Three types of devices covered in a physical security policy include mobile devices, removable media, and facilities."
  },
  {
    "id": 451,
    "topic_id": 200,
    "title": "Be able to name two types of operational policies.",
    "description": "Operational policies include background checks and security clearances."
  },
  {
    "id": 452,
    "topic_id": 200,
    "title": "Describe MFA.",
    "description": "Multifactor authentication is a process that requires two or more methods of verifying identity during the sign\u2010in process."
  },
  {
    "id": 453,
    "topic_id": 200,
    "title": "Describe data classification.",
    "description": "Data classification is a way to classify data based on its sensitivity, type, and value to the organization."
  },
  {
    "id": 454,
    "topic_id": 200,
    "title": "Be able to define need\u2010to\u2010know basis.",
    "description": "Need\u2010to\u2010know concerns relaying the least amount of information needed with only those who have a need\u2010to\u2010know."
  },
  {
    "id": 455,
    "topic_id": 200,
    "title": "Know the difference between analogous, parametric, and bottom\u2010up estimating techniques.",
    "description": "Analogous, or top\u2010down, estimates use expert judgment and historical data to provide a high\u2010level estimate for the entire project, a phase of the project, or a deliverable. Parametric estimates use a mathematical model to create the estimates. The bottom\u2010up method starts at the lowest level of the WBS and calculates the cost of each item within the work packages to obtain a total cost for the project or deliverable."
  },
  {
    "id": 456,
    "topic_id": 200,
    "title": "Name the two discretionary funding allocations a project may receive.",
    "description": "The two types of discretionary funding are a contingency reserve and a management reserve. Contingency reserves are monies set aside to cover the cost of possible adverse events and are used at the discretion of the project manager. Management reserves are set aside by upper management and are used to cover future situations that can't be predicted during project planning."
  },
  {
    "id": 457,
    "topic_id": 200,
    "title": "Explain the purpose of a cost baseline.",
    "description": "The cost baseline is the total approved, expected cost for the project. It's used throughout the project life cycle to monitor the performance of the project budget throughout the project."
  },
  {
    "id": 458,
    "topic_id": 200,
    "title": "Explain the risk identification process.",
    "description": "Risk identification is the process of identifying and documenting the potential risk events that may occur on the project."
  },
  {
    "id": 459,
    "topic_id": 200,
    "title": "Explain the purpose of risk analysis.",
    "description": "Risk analysis evaluates the severity of the impact to the project and the probability that the risk will actually occur."
  },
  {
    "id": 460,
    "topic_id": 200,
    "title": "Be able to name the four risk analysis techniques.",
    "description": "Impact analysis, qualitative analysis, quantitative analysis, and situational/scenario analysis."
  },
  {
    "id": 461,
    "topic_id": 200,
    "title": "Explain Monte Carlo analysis.",
    "description": "Monte Carlo analysis is a simulation technique that uses multiple inputs, usually related to cost and schedule, to estimate potential outcomes for each of the inputs used in the model. This is a \u201cwhat if\u201d\u2010based analysis that is performed multiple times to determine potential outcomes."
  },
  {
    "id": 462,
    "topic_id": 200,
    "title": "Be able to name at least four situational/scenario\u2010based risks.",
    "description": "They are new projects, new management, regulatory environment changes, digital transformation, infrastructure end\u2010of\u2010life, merger and acquisition, reorganization, and cybersecurity events."
  },
  {
    "id": 463,
    "topic_id": 200,
    "title": "Name the negative risk response strategies.",
    "description": "The negative risk response strategies are avoid, transfer, mitigate, and accept."
  },
  {
    "id": 464,
    "topic_id": 200,
    "title": "Name the positive risk response strategies.",
    "description": "The positive risk response strategies are exploit, share, enhance, and accept."
  },
  {
    "id": 465,
    "topic_id": 200,
    "title": "Explain the purpose of risk response planning.",
    "description": "Risk response planning is the process of reviewing the list of potential risks impacting the project to determine what, if any, action should be taken and then documenting it in a response plan."
  },
  {
    "id": 466,
    "topic_id": 200,
    "title": "Describe the importance of communication planning.",
    "description": "Communication planning is the key to project success. It involves determining who needs information, what type, when, in what format, and the frequency of the communication and documenting this in the communication plan."
  },
  {
    "id": 467,
    "topic_id": 200,
    "title": "Describe communication methods.",
    "description": "Communication methods include meetings, email, fax, instant messaging, videoconferencing, voice conferencing, face\u2010to\u2010face, SMS or text messages, distribution of printed media, and social media."
  },
  {
    "id": 468,
    "topic_id": 200,
    "title": "Be able to name the types of meetings on agile teams.",
    "description": "Types of meetings include daily standups, iteration review, backlog refinement, and retrospective."
  },
  {
    "id": 469,
    "topic_id": 200,
    "title": "Name the common communication triggers on any project.",
    "description": "Common communication triggers include audits, project planning, project change, risk register updates, milestones, schedule changes, task initiation/completion, stakeholder changes, gate reviews, business continuity response, incident response, and resource changes."
  },
  {
    "id": 470,
    "topic_id": 200,
    "title": "Describe the factors influencing communication methods.",
    "description": "Factors include language barriers, time zones/geographical factors, technological factors, cultural differences, interorganizational differences, intraorganizational differences, personal preferences, rapport building/relationship building, tailoring of the method based on content of message, criticality factors, and specific stakeholder communication requirements."
  },
  {
    "id": 471,
    "topic_id": 200,
    "title": "Be able to name several communication triggers.",
    "description": "Triggers include audits, project planning, project change, risk register updates, milestones, schedule changes, task initiation/completion, stakeholder changes, phase gate reviews, business continuity response, incident response, and resource changes."
  },
  {
    "id": 472,
    "topic_id": 200,
    "title": "Be able to describe the three meeting types and examples of each.",
    "description": "Collaborative meeting types include workshops, focus groups, JAD sessions, and brainstorming."
  },
  {
    "id": 473,
    "topic_id": 200,
    "title": "Be able to describe the elements required to prepare for meetings.",
    "description": "These elements include creating agendas, determining meeting roles, timeboxing agenda items and meetings, reviewing action items, preparing meeting minutes, and following up."
  },
  {
    "id": 474,
    "topic_id": 200,
    "title": "Be able to name collaboration tools for project communications.",
    "description": "Collaboration tools include multi\u2010authoring and editing software, file\u2010sharing platforms, workflow and e\u2010signature platforms, whiteboards, and a wiki knowledge base."
  },
  {
    "id": 475,
    "topic_id": 200,
    "title": "Name some common meeting tools that assist with preparing, presenting, and obtaining feedback for meetings.",
    "description": "Common meeting tools include real\u2010time surveys and polling, calendaring tools, print media, conferencing platforms, project management scheduling tools, version control tools, and time\u2010tracking tools."
  },
  {
    "id": 476,
    "topic_id": 200,
    "title": "Name three ways to present project status information.",
    "description": "These ways are the project status report, the project dashboard, and charts. Project dashboards are the preferred method for executives."
  },
  {
    "id": 477,
    "topic_id": 200,
    "title": "Be able to describe the difference between a burndown and burnup chart.",
    "description": "A burndown chart shows the remaining work of the iteration. A burnup chart starts at zero and shows the work completed during the iteration along with all of the work of the project."
  },
  {
    "id": 478,
    "topic_id": 200,
    "title": "Name the three elements of maintaining communication records.",
    "description": "Elements of maintaining communication records are security, integrity, and archiving."
  },
  {
    "id": 479,
    "topic_id": 200,
    "title": "Name stakeholder needs regarding communication requirements.",
    "description": "Stakeholder needs include frequency of communication, level of report detail, types of communication, and confidentiality constraints. Make certain to tailor your communication style to the stakeholders\u2019 preference."
  },
  {
    "id": 480,
    "topic_id": 200,
    "title": "Describe the project management plan.",
    "description": "The project management plan is the final, approved, documented plan that's used in the Executing phase to measure project progress."
  },
  {
    "id": 481,
    "topic_id": 200,
    "title": "Be able to describe vendor performance reviews.",
    "description": "They are conducted on a periodic basis to examine the seller's performance to date. Vendor reviews examine scope, quality, budget, schedule, and more. They can be performed using inspections or audits."
  },
  {
    "id": 482,
    "topic_id": 200,
    "title": "Describe the elements of a change control process.",
    "description": "The elements of a change control process include creating and submitting change requests, identifying and documenting the change, conducting a preliminary review, performing impact assessments, documenting change recommendations, determining decision\u2010makers, escalating to the CCB, documenting changes in the change control log, updating the project plan, implementing the change, validating the change, and coordinating and communicating with stakeholders."
  },
  {
    "id": 483,
    "topic_id": 200,
    "title": "Explain the purpose of a CCB.",
    "description": "The change control board reviews, approves, denies, or delays change requests."
  },
  {
    "id": 484,
    "topic_id": 200,
    "title": "Be able to name the types of organizational change.",
    "description": "Organizational change involves transforming processes, systems, organizational structure, personnel, products, applications, and more. The types of organizational change include business merger, acquisition, demerger, split, business process change, internal reorganization, relocation, and outsourcing."
  },
  {
    "id": 485,
    "topic_id": 200,
    "title": "Describe the process steps for organizational change.",
    "description": "The steps define the change, communicate, analyze impacts and responses, training, ensuring adoption over time, communicating during and after the change, documenting the change, creating new knowledge bases, and creating new processes."
  },
  {
    "id": 486,
    "topic_id": 200,
    "title": "Be able to describe operational change control on IT projects.",
    "description": "This involves infrastructure control for managing elements of the IT environment, including hardware, software, and cloud updates."
  },
  {
    "id": 487,
    "topic_id": 200,
    "title": "Be able to describe the three environments on IT projects.",
    "description": "The three environments are development, beta\u2010staging, and production. Development is where code is written, beta\u2010staging is the testing environment, and production is where the live program or application resides."
  },
  {
    "id": 488,
    "topic_id": 200,
    "title": "Describe the agile scaling framework including three examples.",
    "description": "This involves taking agile methodologies and scaling them to the enterprise. Examples include Scrum of Scrums, SAFe, and Disciplined Agile."
  },
  {
    "id": 489,
    "topic_id": 200,
    "title": "Name the seven guiding principles of PRINCE2.",
    "description": "The seven guiding principles are justifying the business need for the project throughout the project life cycle, learning from experience, defining roles and responsibilities, managing work in stages, managing exceptions, focusing on quality, and tailoring the processes."
  },
  {
    "id": 490,
    "topic_id": 200,
    "title": "Be able to name the purpose for controlling quality.",
    "description": "Quality control involves monitoring work results to determine whether they comply with the standards set in the quality management plan."
  },
  {
    "id": 491,
    "topic_id": 200,
    "title": "Name the types of testing performed on technology projects.",
    "description": "The types are smoke, unit, integration, end\u2010to\u2010end, regression, stress, performance, and user acceptance testing."
  },
  {
    "id": 492,
    "topic_id": 200,
    "title": "Be able to explain a histogram.",
    "description": "A histogram displays data distributed over time. It is a type of bar chart."
  },
  {
    "id": 493,
    "topic_id": 200,
    "title": "Be able to explain a fishbone diagram.",
    "description": "A fishbone diagram is a cause\u2010and\u2010effect diagram, also known as an Ishikawa diagram."
  },
  {
    "id": 494,
    "topic_id": 200,
    "title": "Be able to explain a Pareto chart.",
    "description": "A Pareto chart is a histogram that rank\u2010orders data by frequency over time."
  },
  {
    "id": 495,
    "topic_id": 200,
    "title": "Be able to explain a run chart.",
    "description": "A run chart displays data as plots on a timeline."
  },
  {
    "id": 496,
    "topic_id": 200,
    "title": "Be able to explain a control chart.",
    "description": "Control charts measure and display the variance of several samples of the same process over time."
  },
  {
    "id": 497,
    "topic_id": 200,
    "title": "Be able to explain a decision tree.",
    "description": "Decision trees are diagrams that show the sequence of interrelated decisions and the expected results of choosing one alternative over the other."
  },
  {
    "id": 498,
    "topic_id": 200,
    "title": "Be able to explain a scatter diagram.",
    "description": "A scatter diagram displays the relationship between two numerical variables and determines whether they are related to each other. It can also be used to prove or disprove cause\u2010and\u2010effect relationships. Scatter diagrams are also known as correlation charts."
  },
  {
    "id": 499,
    "topic_id": 200,
    "title": "Name the three common causes of variance.",
    "description": "These are random variances, known or predictable variances, and variances that are always present in the process."
  },
  {
    "id": 500,
    "topic_id": 200,
    "title": "Name three actions that you can take when quality is not as expected.",
    "description": "Three actions are rework, process adjustments, and acceptance."
  },
  {
    "id": 501,
    "topic_id": 200,
    "title": "Be able to describe an issue.",
    "description": "An issue is something that could impact the project or delay the completion of deliverables. Risks become issues once they occur."
  },
  {
    "id": 502,
    "topic_id": 200,
    "title": "Be able to describe the issue log.",
    "description": "The issue log is where information about issues are logged and may include an identification number, description, priority ranking, resolution plan, and other information."
  },
  {
    "id": 503,
    "topic_id": 200,
    "title": "Name the performance measurement tools that can be used for quality assessments.",
    "description": "They are key performance indicators (KPIs), balanced scorecards, key objectives and results, and cost and schedule performance measures."
  },
  {
    "id": 504,
    "topic_id": 200,
    "title": "Name the four reasons for project endings.",
    "description": "They are addition, starvation, integration, and extinction."
  },
  {
    "id": 505,
    "topic_id": 200,
    "title": "Understand the steps involved in closing a project.",
    "description": "The steps are verification and validation of deliverables, obtaining sign\u2010off, transition plan creation, revoking access, releasing project resources, closing out contracts, archiving documents, lessons learned, closure meeting, closeout report, celebration, and postimplementation support and warranty period."
  },
  {
    "id": 506,
    "topic_id": 200,
    "title": "Explain the purpose of obtaining formal customer or stakeholder sign\u2010off.",
    "description": "The formal sign\u2010off documents that the customer accepts the project work and that the project meets the defined requirements. It also signals the official closure of the project and the transfer of the final product of the project to the organization."
  },
  {
    "id": 507,
    "topic_id": 200,
    "title": "Describe lessons learned.",
    "description": "Lessons learned describe the successes and failures of the project."
  }
];
